import React, { useState, useEffect, useRef } from "react";
import Header from "../../Components/Header/Header";
import Footer from "../../Components/Footer/Footer";
import Camperdetails from "../../Components/Camperdetails/Camperdetails";
import { Button } from "react-bootstrap";
import { NumericFormat } from "react-number-format";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import { useTranslation } from "react-i18next";
import "slick-carousel/slick/slick-theme.css";
import {
  useLocation,
  Link,
  useParams,
  useSearchParams,
  useNavigate,
  createSearchParams,
  generatePath,
} from "react-router-dom";
import CamperService from "../../Api/services/CamperService";
import HomeService from "../../Api/services/HomeService";
import DatePicker, { registerLocale } from "react-datepicker";
import moment, { daysInMonth } from "moment";
import { addMonths, getDate, add, differenceInDays, getMonth } from "date-fns";
import "react-datepicker/dist/react-datepicker.css";
import Select from "react-select";
import Loader2 from "../../Components/Loader/loader2";
import de from 'date-fns/locale/de';
import { Helmet } from "react-helmet";
import { addDays, format } from "date-fns";
import "moment/locale/de";
import YouTubeFacade from "../../Components/YouTubeFacade/YouTubeFacade";
registerLocale("de", de);

const AvailabilityinfoSubscription = () => {
  var imageUrl = process.env.REACT_APP_LARAVEL_CAMPER_IMAGE_URL;
  const daysRange = parseInt(process.env.REACT_APP_DAYS_RANGE);
  const params = useParams();
  const { i18n, t } = useTranslation();
  const navigate = useNavigate();
  const [imageloader, setImageLoader] = useState(true);
  const [totalcamperprice, setTotalcamperprice] = useState();
  const [error, setError] = useState("");
  const [errorStartDate, setErrorStartDate] = useState("");
  const [errorMonthselect, setErrorMonthselect] = useState("");
  const [camper, setCamper] = useState([]);
  const [restrictedDateList, setRestrictedDateList] = useState([]);
  const [unavailableDateList, setUnavailableDateList] = useState([]);
  const [PickupandReturnDateList, setPickupandReturnDateList] = useState([]);
  const [calendarIsOpen, setCalendarIsOpen] = useState(false);
  const [startDate, setStartDate] = useState(null);
  const [ExcludedateList, setExcludedateList] = useState([]);
  const [endDate, setEndDate] = useState(null);
  const [monthselect, setMonthselect] = useState(null);
  const [skills, setSkills] = useState([]);
  const [count, setCount] = useState(0);
  const [searchParams, setSearchParams] = useSearchParams();
  const variable = useLocation();
  const [nav1, setNav1] = useState(null);
  const [nav2, setNav2] = useState(null);
  const [slider1, setSlider1] = useState(null);
  const [slider2, setSlider2] = useState(null);
  const [period, setPeriod] = useState([]);
  const [campermonthprice, setCampermonthprice] = useState([]);
  const [periodData, setPeriodData] = useState([]);
  const [gallery, setGallery] = useState([]);
  const [isCalendarStatus, setIsCalendarStatus] = useState('');
  const [subscriptionDiscounts, setSubscriptionDiscounts] = useState({});
  const today = new Date();
  const minSelectableDate = new Date(today);
  minSelectableDate.setDate(today.getDate() + 1);

  const [isMobile, setIsMobile] = useState(window.innerWidth < 1200);
  const pickerRef = useRef(null);
  const handlePopstate = () => {
    navigate(-1)
  };
  // const monthoptions = [
  //   { value: '2', label: 2 + " " + t("Rent.Months") },
  //   { value: '3', label: 3 + " " + t("Rent.Months") },
  //   { value: '4', label: 4 + " " + t("Rent.Months") },
  //   { value: '5', label: 5 + " " + t("Rent.Months") },
  //   { value: '6', label: 6 + " " + t("Rent.Months") },
  //   { value: '7', label: 7 + " " + t("Rent.Months") },
  //   { value: '8', label: 8 + " " + t("Rent.Months") },
  //   { value: '9', label: 9 + " " + t("Rent.Months") },
  //   { value: '10', label: 10 + " " + t("Rent.Months") },
  //   { value: '11', label: 11 + " " + t("Rent.Months") },
  //   { value: '12', label: 12 + " " + t("Rent.Months") }
  // ]
  useEffect(() => {


    window.addEventListener('popstate', handlePopstate);

    return () => {
      window.removeEventListener('popstate', handlePopstate);


    };
  }, []);
  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 1200);
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  useEffect(() => {
    if (isMobile && pickerRef.current !== null) {
      pickerRef.current.input.readOnly = true;
    }
  }, [isMobile, pickerRef]);

  const settingsMain = {
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    fade: true,
    asNavFor: nav2,
  };

  const settingsThumbs = {
    slidesToShow: 6,
    slidesToScroll: 1,
    asNavFor: nav1,
    dots: false,
    arrows: true,
    swipeToSlide: true,
    focusOnSelect: true,
    centerPadding: "5px",
    infinite: false,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          arrows: false,
        },
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 3,
          arrows: false,
        },
      },
    ],
  };


  useEffect(() => {
    var id = params.id;
    getCamperByDataID(id);
    getExcludedate(id);
    getUnavailableDate(id);
    PickupandReturnDateAPI();
    getRestrictedDate(id);
    getLocation();
    getPeriod();
    discountMonthsList();
    // NO default selection
    // let daterange = searchParams.get("date");
    // if (daterange === null) {
    //   setSearchParams((searchParams) => {
    //     searchParams.set("date", `${moment(minSelectableDate).format("YYYY-MM-DD")}`);
    //     return searchParams;
    //   });
    // }

    // if (dateRange) {

    //   var threeMonthsAgo = moment(dateRange).add(2, 'months');

    //   setEndDate(threeMonthsAgo.toDate())
    //   let result = 0;

    //   result = differenceInDays(threeMonthsAgo.toDate(), new Date(dateRange))
    //   setCount(result)
    //   setStartDate(new Date(dateRange));
    // }
    // else {
    //   var threeMonthsAgo = moment(startDate).add(2, 'months');

    //   setEndDate(threeMonthsAgo.toDate())
    //   let result = 0;

    //   result = differenceInDays(threeMonthsAgo.toDate(), startDate)

    //   setCount(result)
    //   setSearchParams((searchParams) => {
    //     searchParams.set('date', `${moment(startDate).format('YYYY-MM-DD')}`);
    //     return searchParams;
    //   });
    // }
    // NO default selection
    // var monthdata = monthoptions.map((element) => {
    //   return element;
    // });
    // setMonthselect(monthdata[0]);

    setNav1(slider1);
    setNav2(slider2);
  }, []);

  const getSubscriptionDiscount = (months) => {
    return subscriptionDiscounts[months] || 0;
  };

  const monthoptions = Array.from({ length: 11 }, (_, i) => i + 2).map((month) => {
    const discount = getSubscriptionDiscount(month);
    const labelDiscount = discount > 0 ? ` (-${discount}%)` : "";

    return {
      value: month.toString(),
      label: `${month} ${t("Rent.Months")}${labelDiscount}`
    };
  });

  const getCamperByDataID = async (id) => {
    try {
      let getCamper = await CamperService.show(id).json();

      setGallery(getCamper.data.gallery);
      setCamper(getCamper.data);
      setIsCalendarStatus(getCamper.data.is_calendar)
      setImageLoader(false);
      setCampermonthprice(getCamper.data.month_setails);
      let dateRange = searchParams.get("date");
      var current_month = new Date(dateRange).getMonth() + 1;
      if (dateRange) {
        setStartDate(new Date(dateRange));
        var monthdata = monthoptions.map((element) => {
          return element;
        });
        var rangedate = {};
        var localMonth = localStorage.getItem("Monthselect")
        var monthdata = monthoptions.map((element) => { return element })
        setMonthselect(monthdata[0])
        rangedate = moment(dateRange).add(2, 'months');
        // if (localStorage.getItem("Monthselect") === null) {
        //   var monthdata = monthoptions.map((element) => { return element })
        //   setMonthselect(monthdata[0])
        //   rangedate = moment(dateRange).add(2, 'months');
        // }
        // else {
        //   var monthdata = monthoptions.filter((element) => { return element.value === localMonth })
        //   setMonthselect(monthdata[0])

        //   rangedate = moment(dateRange).add(localMonth, 'months');
        // }
        // var rangedate = moment(dateRange).add(2, 'months');

        setEndDate(rangedate.toDate())
        // setEndDate(rangedate.toDate())
        // var now = new Date();
        // var current_month = new Date(dateRange).getMonth() + 1;
        // const totalDays = new Date(now.getFullYear(), now.getMonth() + 1, 0).getDate();
        // const currentDays = new Date(dateRange).getDate();
        // var startdatemonthprice = getCamper.data.month_setails.filter((element) => { return element.month_id === current_month })
        // var mp1 = (Math.ceil((startdatemonthprice[0].month_price) / totalDays) * ((totalDays - currentDays) + 1));

        // var threeMonthsAgo = moment(dateRange).add(2, 'months');

        // var last_month = threeMonthsAgo.toDate().getMonth() + 1
        // const totalDayslast = new Date(now.getFullYear(), threeMonthsAgo.toDate().getMonth() + 1, 0).getDate();
        // const lastcurrentDays = new Date(threeMonthsAgo).getDate();

        // var enddatemonthprice = getCamper.data.month_setails.filter((element) => { return element.month_id === last_month })
        // var mp2 = (Math.ceil((enddatemonthprice[0].month_price) / totalDayslast) * (lastcurrentDays));
        // let result = 0;
        // var rangedate = moment(dateRange).add(2, 'months');
        // setEndDate(rangedate.toDate())
        // result = differenceInDays(rangedate.toDate(), new Date(dateRange))
        // setCount(result)
        // var betweenmonth = [];
        // if (current_month >= last_month) {
        //   for (var i = (current_month + 1); i <= 12; i++) {
        //     betweenmonth.push(i);
        //   }
        //   for (var i = 1; i < last_month; i++) {
        //     betweenmonth.push(i);
        //   }
        // } else {
        //   for (var i = (current_month + 1); i < last_month; i++) {
        //     betweenmonth.push(i);
        //   }

        // }
        // const betweenmonthday = getCamper.data.month_setails.filter(col => {
        //   return betweenmonth.find(selected => selected === col.month_id)
        // })
        // // var totalNumber = Number(betweenmonthday[0].month_price) + Number(mp1) + Number(mp2);
        // var totalNumber = betweenmonthday.reduce((a, b) => a + parseInt(b.month_price), Number(mp1) + Number(mp2))

        setTotalcamperprice(getCamper.data.campernew_price);
      }
    } catch (error) {
      if (error.name === "HTTPError") {
        const errorJson = await error.response.json();

        setError(
          errorJson.message.substr(0, errorJson.message.lastIndexOf("."))
        );
      }
    }
  };

  const discountMonthsList = async () => {
    try {
      const response = await CamperService.discountMonthsList().json();
      const discountMap = {};
      if (response.status) {
        response?.month?.forEach((item) => {
          discountMap[item.key] = item.value;
        });
      }
      setSubscriptionDiscounts(discountMap);
    } catch (error) {
      console.error(error);
    }
  };

  const getExcludedate = async (id) => {
    try {
      let Excludedate = await CamperService.excludedates(id).json();
      if (Excludedate.message === "Inventory not avalable!!!") {
        const daysRange = parseInt(process.env.REACT_APP_DAYS_RANGE);

        var newinverntory = [];
        for (let i = 0; i < daysRange; i++) {
          newinverntory.push(add(new Date(), { days: i }));
        }

        setExcludedateList(newinverntory);
      } else if (Excludedate.message === "Excluded dates listing") {
        setExcludedateList(Excludedate.exclude_date);
      } else {
        console.log("");
      }
    } catch (error) {
      if (error.name === "HTTPError") {
        const errorJson = await error.response.json();
        setError(
          errorJson.message.substr(0, errorJson.message.lastIndexOf("."))
        );
      }
    }
  };
  const getLocation = async () => {
    try {
      let locationList = await HomeService.location().json();
      var getData = locationList.data.filter((element) => {
        return element.title === "Berlin";
      });

      setSearchParams((searchParams) => {
        searchParams.set("location", `${getData[0].id}`);
        return searchParams;
      });

      setSkills(getData);
    } catch (error) {
      console.log(error);
    }
  };
  const getPeriod = async () => {
    try {
      let periodList = await HomeService.period().json();
      setPeriod(periodList.data);
      let getdata = periodList.data.filter(function (item) {
        return item.id == searchParams.get("duration");
      });
      setPeriodData(getdata);
    } catch (error) {
      console.log(error);
    }
  };
  const handleCheckout = async (id) => {
    if (ExcludedateList.length == daysRange) {
      setError(t("rentinfo.Inventory is not available"));
      return;
    }
    if (!startDate) {
      setErrorStartDate(t("Rent.Select a start date"));
      return;
    }
    if (!monthselect) {
      setErrorMonthselect(t("Rent.Select a duration"));
      return;
    }

    else {
      let today = moment(); // This will get the current date and time
      let formattedToday = today.format("YYYY-MM-DD");
      let oneYearLater = today.add(730, 'days');
      let formattedOneYearLater = oneYearLater.format("YYYY-MM-DD");
      let userData = {
        campersubscription_id: params.id,
        startdate: moment(startDate).format("YYYY-MM-DD"),
        enddate: moment(endDate).format("YYYY-MM-DD")
      }
      // if (moment(userData.startdate).isBetween(formattedToday, formattedOneYearLater, null, '[]') &&
      //   moment(userData.enddate).isBetween(formattedToday, formattedOneYearLater, null, '[]'))
      if (moment(userData.startdate) &&
        moment(userData.enddate)) {
        
      const isRestricted = isCalendarStatus !== 1 && restrictedDateList.some(
          (d) => format(new Date(d), "yyyy-MM-dd") === moment(startDate).format("yyyy-MM-DD")
        );
        if(isRestricted){
        let getcheckaccessoires = await CamperService.checkunavailabledate(userData).json();
        if (getcheckaccessoires.success === false) {
          // alert(getcheckaccessoires.message)
          setError(t("Rent.Vehicle not available"))
          return;
        }
        }
        
        else {
          getCamperCheckDate(id);
          setError("");
        }
      }
      else {
        setError(t("Rent.Vehicle not available"))
        // let getcheckaccessoires = await CamperService.checkunavailabledate(userData).json();
        // if (getcheckaccessoires.success === false) {
        //   // alert(getcheckaccessoires.message)
        //   alert(t("Rent.Vehicle not available"))
        //   return;
        // }
        // else {
        //   getCamperCheckDate(id);
        //   setError("");
        // }
      }
      // let userData = {
      //   campersubscription_id: params.id,
      //   startdate: moment(startDate).format("YYYY-MM-DD"),
      //   enddate: moment(endDate).format("YYYY-MM-DD")
      // }
      // let getcheckaccessoires = await CamperService.checkunavailabledate(userData).json();
      // if (getcheckaccessoires.success === false) {

      //   setError(t("Rent.Vehicle not available"))

      // }
      // else {
      //   getCamperCheckDate(id);
      //   setError("");
      // }

    }
  };
  const handleMonth = (e) => {
    setMonthselect(e);
    if (e) {
      localStorage.setItem("Monthselect", e.value);
      
      // Only calculate end date if startDate exists
      if (startDate) {
        var rangedate = moment(startDate).add(e.value, 'months');
        setEndDate(rangedate.toDate());
      }
    }
    localStorage.setItem("Monthselect", e.value)
    var rangedate = moment(startDate).add(e.value, 'months');

    setEndDate(rangedate.toDate())
    // var threeMonthsAgo = moment(startDate).add(e.value, 'months');
    // setEndDate(threeMonthsAgo.toDate())
    // let result = 0;
    // result = differenceInDays(threeMonthsAgo.toDate(), startDate)

    // setCount(result)

    // var now = new Date();
    // var current_month = startDate.getMonth() + 1;
    // const totalDays = new Date(
    //   now.getFullYear(),
    //   now.getMonth() + 1,
    //   0
    // ).getDate();
    // const currentDays = new Date(startDate).getDate();
    // var startdatemonthprice = campermonthprice.filter((element) => {
    //   return element.month_id === current_month;
    // });
    // var mp1 =
    //   Math.ceil(startdatemonthprice[0].month_price / totalDays) *
    //   (totalDays - currentDays + 1);

    // var threeMonthsAgo = moment(startDate).add(e.value, "months");
    // var last_month = threeMonthsAgo.toDate().getMonth() + 1;
    // const totalDayslast = new Date(
    //   now.getFullYear(),
    //   threeMonthsAgo.toDate().getMonth() + 1,
    //   0
    // ).getDate();
    // const lastcurrentDays = new Date(threeMonthsAgo).getDate();
    // var enddatemonthprice = campermonthprice.filter((element) => {
    //   return element.month_id === last_month;
    // });
    // var mp2 =
    //   Math.ceil(enddatemonthprice[0].month_price / totalDayslast) *
    //   lastcurrentDays;
    // //alert(mp2)
    // var betweenmonth = [];
    // if (current_month >= last_month) {
    //   for (var i = current_month + 1; i <= 12; i++) {
    //     betweenmonth.push(i);
    //   }
    //   for (var i = 1; i < last_month; i++) {
    //     betweenmonth.push(i);
    //   }
    // } else {
    //   for (var i = current_month + 1; i < last_month; i++) {
    //     betweenmonth.push(i);
    //   }
    // }
    // const betweenmonthday = campermonthprice.filter((col) => {
    //   return betweenmonth.find((selected) => selected === col.month_id);
    // });
    // // var totalNumber = Number(betweenmonthday[0].month_price) + Number(mp1) + Number(mp2);
    // var totalNumber = betweenmonthday.reduce(
    //   (a, b) => a + parseInt(b.month_price),
    //   Number(mp1) + Number(mp2)
    // );
    // setTotalcamperprice(totalNumber);
  };

  const getCamperCheckDate = async (id) => {
    const oneDate = moment(startDate).format("YYYY-MM-DD");
    const twoDate = moment(endDate).format("YYYY-MM-DD");
    console.log(endDate)
    // console.log(twoDate);
    try {
      var userData = {
        id: id,
        startdate: oneDate,
        enddate: twoDate,
      };

      let responseData = await CamperService.checkdate(userData).json();

      if (responseData.status === false) {
        setError(t("Rent.Camper not available!!!"));
      } else {
        navigate(
          `/subscriptiondetail/${camper.id}?location=${searchParams.get(
            "location"
          )}&date=${searchParams.get("date")}&pickup=14&return=11`, { state: monthselect }
        );
      }
      console.log(monthselect, "monthselect")
      // setError(responseData.message)
    } catch (error) {
      if (error.name === "HTTPError") {
        const errorJson = await error.response.json();
        setError(
          errorJson.message.substr(0, errorJson.message.lastIndexOf("."))
        );
      }
    }
  };
  const getUnavailableDate = async (id) => {
    try {
      let userData = {
        campersubscriptionid: id
      }
      let UnavailableDate = await CamperService.unavailabledate(userData).json();
      if (UnavailableDate.status) {
        const excluded = UnavailableDate.data.campersubscription.flatMap(({ startdate, enddate }) => {
          const start = new Date(startdate);
          const end = new Date(enddate);
          const dates = [];
          for (let d = start; d <= end; d = addDays(d, 1)) {
            dates.push(d);
          }
          return dates;
        });
        setUnavailableDateList(excluded);
      } else {
        console.log(UnavailableDate.status)
      }
    }
    catch (error) {
      if (error.name === 'HTTPError') {
        const errorJson = await error.response.json();
        setError(errorJson.message.substr(0, errorJson.message.lastIndexOf(".")))
      }
    }
  };
  const PickupandReturnDateAPI = async () => {
    //pick up and return not possible
    try {

      let PickupandReturnDate = await CamperService.pickupreturndate().json();

      if (PickupandReturnDate.status) {
        setPickupandReturnDateList(PickupandReturnDate.subscription_camper_dates);
      } else {
        console.log(PickupandReturnDate.status)
      }
    }
    catch (error) {
      if (error.name === 'HTTPError') {
        const errorJson = await error.response.json();
        setError(errorJson.message.substr(0, errorJson.message.lastIndexOf(".")))
      }
    }

  }
  const getRestrictedDate = async (id) => {
    try {
      let userData = {
        campersubscriptionid: id
      }
      let restrictedDateList = await CamperService.restricteddate(userData).json();

      if (restrictedDateList.status) {
        const excluded = restrictedDateList.data.campersubscription.flatMap(({ startdate, enddate }) => {
          const start = new Date(startdate);
          const end = new Date(enddate);
          const dates = [];
          for (let d = start; d <= end; d = addDays(d, 1)) {
            dates.push(d);
          }
          return dates;
        });
        setRestrictedDateList(excluded);
      } else {
        console.log("")
      }
    }
    catch (error) {
      if (error.name === 'HTTPError') {
        const errorJson = await error.response.json();
        setError(errorJson.message.substr(0, errorJson.message.lastIndexOf(".")))
      }
    }
  };
  const onChangedate = async (date) => {
    setStartDate(date);

    var rangedate = moment(date).add(monthselect?.value, 'months');

    setEndDate(rangedate.toDate())

    if (date !== null) {
      let userData = {
        campersubscription_id: params.id,
        startdate: moment(date).format("YYYY-MM-DD"),
        enddate: moment(rangedate).format("YYYY-MM-DD")
      }

      let today = moment(); // This will get the current date and time
      let formattedToday = today.format("YYYY-MM-DD");
      let oneYearLater = today.add(730, 'days');
      let formattedOneYearLater = oneYearLater.format("YYYY-MM-DD");

      if (moment(userData.startdate) &&
        moment(userData.enddate)) {
         const isRestricted = isCalendarStatus !== 1 && restrictedDateList.some(
          (d) => format(new Date(d), "yyyy-MM-dd") === moment(date).format("yyyy-MM-DD")
        );
         if (isRestricted) {
           let getcheckaccessoires = await CamperService.checkunavailabledate(userData).json();
        if (getcheckaccessoires.success === false) {
          // alert(getcheckaccessoires.message)
          alert(t("Rent.Vehicle not available"))
          return;
        }
         }

       
        else {
          if (variable.search == "") {
            navigate(generatePath(`?date=${moment(date).format("YYYY-MM-DD")}`));
          } else if (variable.search !== "") {
            setSearchParams((searchParams) => {
              searchParams.set("date", `${moment(date).format("YYYY-MM-DD")}`);
              return searchParams;
            });
          } else {
            navigate(
              generatePath(
                variable.search + `&date=${moment(date).format("YYYY-MM-DD")}`
              )
            );
          }
        }
      } else {
        alert(t("Rent.Vehicle not available"))
        return;
      }




    }

    // var threeMonthsAgo = moment(date).add(monthselect.value, 'months');
    // setEndDate(threeMonthsAgo.toDate())
    // let result = 0;
    // result = differenceInDays(threeMonthsAgo.toDate(), date)
    // setStartDate(date);
    // if (searchParams.get('pickup') < 14 || searchParams.get('return') > 11) {
    //   setCount(0.5 + result)
    // }
    // else {
    //   setCount(result)
    // }

    // if (date !== null) {
    //   if (variable.search == '') {
    //     navigate(generatePath(`?date=${moment(date).format('YYYY-MM-DD')}`))
    //   } else if (variable.search !== '') {
    //     setSearchParams((searchParams) => {
    //       searchParams.set('date', `${moment(date).format('YYYY-MM-DD')}`);
    //       return searchParams;
    //     });
    //   } else {
    //     navigate(generatePath(variable.search + `&date=${moment(date).format('YYYY-MM-DD')}`))
    //   }
    // }
  };
  const excludeDates = [];
  // ExcludedateList.map((element) => {
  //   return excludeDates.push(new Date(element));
  // });
  var getexdates = ExcludedateList.map((element) => { return excludeDates.push(new Date(element)) });
  var getrestricted = restrictedDateList.map((element) => { return excludeDates.push(new Date(element)) });
  var getunavailable = unavailableDateList.map((element) => { return excludeDates.push(new Date(element)) });
  var getpickupandReturn = PickupandReturnDateList.map((element) => { return excludeDates.push(new Date(element)) });

  const renderDayContents = (day, date) => {
    const isRestricted = isCalendarStatus !== 1 && restrictedDateList.some(
      (d) => format(d, "yyyy-MM-dd") === format(date, "yyyy-MM-dd")
    );
    const isPickupandReturn = isCalendarStatus !== 1 && PickupandReturnDateList.some(
      (d) => {
        // Convert d to a Date object if it's not already one
        const dateToCheck = new Date(d);

        // Ensure that d is a valid date
        if (isNaN(dateToCheck)) {

          return false;
        }

        // Ensure that 'date' is also a valid Date object
        const dateToCompare = new Date(date);
        if (isNaN(dateToCompare)) {

          return false;
        }

        return format(dateToCheck, "yyyy-MM-dd") === format(dateToCompare, "yyyy-MM-dd");
      }
    );

    const isUnavailable = isCalendarStatus !== 1 && unavailableDateList.some(
      (d) => format(d, "yyyy-MM-dd") === format(date, "yyyy-MM-dd")
    );
    var filtered = camper.camper_price.filter((element) => {
      const date = element.startdate;

      return date === moment(date).format("YYYY/MM/DD");
    });

    var getdate = filtered.map((camper_price) => {
      return camper_price.startdate;
    });

    var getenddate = filtered.map((camper_price) => {
      return camper_price.enddate;
    });
    var monthprice = campermonthprice.map((element) => {
      return element;
    });
    var getprice =
      camper.camper_price &&
      camper.camper_price.map((camper_price) => {
        return camper_price.price;
      });

    let formetDates = moment(date).format("YYYY/MM/DD").indexOf(getdate) != 0;

    var newdata = monthprice.filter((element) => {
      return element.month_id === getMonth(date) + 1;
    });
    var newarray = newdata.map((element) => {
      return element.month_price;
    });

    return (
      // <span>
      //   {getDate(date)}
      //   <p className="price-font">{formetDates ? "" : "€" + newarray}</p>
      // </span>
      // <span style={{ backgroundColor: isUnavailable ? "red" : isRestricted ? "orange" : "", border: isUnavailable ? "3px solid red" : isRestricted ? "3px solid orange" : "", borderRadius: (isUnavailable || isRestricted) ? "1rem" : "", color: (isUnavailable || isRestricted) ? "white" : "" }}>
      <span style={{ backgroundColor: isUnavailable ? "red" : isRestricted ? "orange" : isPickupandReturn ? "orange" : "", border: isUnavailable ? "3px solid red" : isRestricted ? "3px solid orange" : isPickupandReturn ? "3px solid orange" : "", borderRadius: (isUnavailable || isRestricted || isPickupandReturn) ? "1rem" : "", color: (isUnavailable || isRestricted || isPickupandReturn) ? "white" : "" }}>
        {getDate(date)}
        {/* <p className="price-font">{formetDates ? "" : "€" + newarray}</p> */}
      </span>
    );
  };
  const handleBack = () => {
    navigate("/campersubscription");
  };

  // Slider  Gallery click
  const [showResults, setShowResults] = React.useState(false);
  const onClick = () => setShowResults(true);
  const onClose = () => setShowResults(false);

  const getSeasonalInfo = (currentDate) => {
    const monthIndex = currentDate.getMonth();
    const monthId = monthIndex + 1;
    const isWinter = monthId === 11 || monthId === 12 || monthId <= 3;

    const seasonInfo = isWinter
      ? {
        title: t("Rent.Winter Pricing (November to March)"),
        theme: "blue",
        icon: <svg xmlns="http://www.w3.org/2000/svg" fill="#4a6cab" width="800px" height="800px" viewBox="0 0 24 24" id="winter-ice" class="icon glyph"><path d="M21,11H18.87l1-1.45a1,1,0,1,0-1.66-1.1L16.46,11H14.83A3,3,0,0,0,13,9.17V7.54l2.55-1.71a1,1,0,0,0-1.1-1.66L13,5.13V3a1,1,0,0,0-2,0V5.13l-1.45-1a1,1,0,0,0-1.1,1.66L11,7.54V9.17A3,3,0,0,0,9.17,11H7.54L5.83,8.45a1,1,0,0,0-1.66,1.1l1,1.45H3a1,1,0,0,0,0,2H5.13l-1,1.45a1,1,0,0,0,.28,1.38A.94.94,0,0,0,5,16a1,1,0,0,0,.83-.45L7.54,13H9.17A3,3,0,0,0,11,14.83v1.63L8.45,18.17a1,1,0,0,0,1.1,1.66l1.45-1V21a1,1,0,0,0,2,0V18.87l1.45,1A.94.94,0,0,0,15,20a1,1,0,0,0,.55-1.83L13,16.46V14.83A3,3,0,0,0,14.83,13h1.63l1.71,2.55A1,1,0,0,0,19,16a.94.94,0,0,0,.55-.17,1,1,0,0,0,.28-1.38l-1-1.45H21a1,1,0,0,0,0-2Zm-9,2a1,1,0,1,1,1-1A1,1,0,0,1,12,13Z" /></svg>,
      }
      : {
        title: t("Rent.Summer Pricing (April to October)"),
        theme: "orange",
        icon: "☀️",
      };

    let monthPrice = 0;

    if (camper?.month_setails?.length) {
      const monthData = camper.month_setails.find(
        (m) => Number(m.month_id) === monthId
      );

      if (monthData?.month_price) {
        monthPrice = Math.round(parseFloat(monthData.month_price));
      }
    }

    return {
      ...seasonInfo,
      price: monthPrice,
    };
  };

  return (
    <>
      <Header />
      {/* background image */}

      <img
        class="hero-img-campers inline-block max-w-full object-cover dark:brightness-90 aspect-square w-full group-hover:scale-110 transition-all duration-300"
        src={imageUrl + camper.background_image}
        alt="clara"
      />
      {imageloader ? (
        <Loader2 />
      ) : (
        <>
          <main className="min-h-screen bg-off-white">
            {
              i18n.resolvedLanguage === 'en' ?
                <Helmet>
                  <title>Flexible Camper Subscription Plans from 499€/Month |Born To Camp</title>
                  <meta name="description" content="Explore camper subscription options from 499€/month. Enjoy flexible terms, no hidden costs, and a fully equipped home on wheels with Born To Camp." />

                </Helmet>
                :
                i18n.resolvedLanguage === 'de' ?
                  <Helmet>
                    <title>Flexibles Camper Abo ab 499€ pro Monat | Born To Camp</title>
                    <meta name="description" content="Entdecke das Camper-Abo von Born To Camp ab 499€/Monat. Wähle dein Modell und genieße deine Camper Langzeitmiete. Jetzt Abenteuer buchen! " />

                  </Helmet>
                  : ""

            }

            <div className="md:mb-8 mb-2 flex max-w-screen-xl lg:mx-5 lg:grid lg:grid-cols-12 xl-padded:mx-auto pt-100 hero-img-padding">

              <div className="mx-auto w-full lg:col-span-8 xl:px-12 2xl:px-0">
                <div className="slider-wrapper">
                  <div className="top-slider">
                    <Slider
                      className="slider-main camper-slider camper-slider"
                      {...settingsMain}
                      // asNavFor={nav2}
                      ref={(slider) => setNav1(slider)}
                    >
                      <div className="item cursor-pointer" onClick={onClick}>
                        <img
                          class="main-img rounded"
                          src={imageUrl + camper.image}
                          alt="clara"
                        />
                      </div>
                      {gallery &&
                        gallery.map((images) => (
                          <div
                            className="item cursor-pointer"
                            onClick={onClick}
                          >
                            <img
                              class="main-img rounded"
                              src={imageUrl + images}
                              alt="clara"
                            />
                          </div>
                        ))}
                    </Slider>
                    {showResults ? (
                      <div className="top-equipped-modal gallery-popup">
                        <div className="custom-popup">
                          <div className="text-right mb-5">
                            <button
                              onClick={onClose}
                              className="close-top-eq-mdal"
                            >
                              X
                            </button>
                          </div>

                          <div className="image-gallery-popup">
                            <div className="item ">
                              <img
                                class="main-img rounded"
                                src={imageUrl + camper.image}
                                alt="clara"
                              />
                            </div>
                            {gallery &&
                              gallery.map((images) => (
                                <div className="item ">
                                  <img
                                    class="main-img rounded"
                                    src={imageUrl + images}
                                    alt="clara"
                                  />
                                </div>
                              ))}
                          </div>
                          <div className="min-h-[70px] break-words text-sm 2xl:text-2md 2xl:font-normal"></div>
                          <div className="fixed bottom-0 left-0 flex w-full justify-center bg-black/80 backdrop-blur-md">
                            <button
                              className="group/button block disabled:opacity-50 border border-transparent rounded-full text-md text-white dark:text-off-white bg-primary p-2 px-5 hover:bg-secondary group-hover/parent:bg-secondary dark:hover:text-off-black dark:group-hover/parent:text-off-black dark:hover:bg-off-white dark:group-hover/parent:bg-off-white transition-all not-oblique hover:oblique group-hover/parent:oblique cssvar-secondary-to-current m-3 w-96 max-w-full 2xl:m-5"
                              onClick={onClose}
                            >
                              <div className="flex h-full items-center justify-center">
                                <span className="flex">{t("Rent.Close view")}</span>
                              </div>
                            </button>
                          </div>
                        </div>
                      </div>
                    ) : null}
                  </div>
                  <div className="bottom-slider">
                    <Slider
                      {...settingsThumbs}
                      // asNavFor={nav1}
                      ref={(slider) => setNav2(slider)}
                      className="slider-thumbnail camper-slider camper-slider"
                    >
                      <div className="item">
                        <img
                          class="thumb-slider-img"
                          src={imageUrl + camper.image}
                          alt="clara"
                        />
                      </div>
                      {gallery &&
                        gallery.map((images) => (
                          <div className="item">
                            <img
                              class="thumb-slider-img"
                              src={imageUrl + images}
                              alt="clara"
                            />
                          </div>
                        ))}
                    </Slider>
                  </div>
                </div>
                {/* mobile */}
                <div className="flex justify-center md:pt-8 lg:hidden mx-5">
                  <div className="overflow-hidden rounded bg-white shadow dark:bg-off-black-desat dark:shadow-dark 2xs:rounded-lg mt-1 md:mt-8 p-5 md:pt-7 pt-0 transition-all duration-300 lg:block top-6 pb-3 w-100">
                    <div className="flex max-h-[calc(100vh-80px)] flex-col custom-max-h">
                      <div className="flex max-h-full flex-col items-center overflow-auto text-center">
                        <div className="mb-5 flex items-center justify-center 2xl:mb-2 2xl:flex-col">
                          {camper.technical &&
                            camper.technical.map((technical) => <></>)}
                        </div>
                        <h2 className="md:mb-4 mb-2 whitespace-pre-line text-xl 2xl:text-2xl price-font fw-600">
                          {camper.title}
                        </h2>
                        {camper.camper_details &&
                          camper.camper_details.map((camper_details) => (
                            <h3 className="md:mb-4 mb-2 text-lg">
                              {camper_details.sub_title}
                            </h3>
                          ))}
                        <form className="w-full" action="">
                          <input type="hidden" name="lang" value="en" />
                          <input type="hidden" name="camper" value="1040" />
                          <div className="relative w-full my-2 custom-select location"></div>
                          <h4 className="mb-1">{t("Rent.Start-Date")}</h4>
                          <div className="relative w-full">
                            <span className="flex h-14 w-full items-center bg-white dark:bg-off-black-desat transition-all child-span:overflow-hidden child-span:text-ellipsis border focus:border-primary focus:outline-none justify-between border-grey hover:shadow dark:border-grey-dark dark:hover:shadow-dark rounded">
                              <div className="inline-block align-top ml-3 mr-1 min-w-fit child:h-7 child:w-7 dark:cssvar-secondary-to-off-white">
                                <svg width="32" height="32" viewBox="0 0 32 32">
                                  <g fill="none" fillRule="evenodd">
                                    <path
                                      d="M21.06 4.5c.474 0 .884.3 1.01.741l.028.124.01.127-.002 1.327h1.14c1.503 0 2.772 1.005 3.049 2.362l.03.179.019.182.006.183v13.87c0 1.476-1.178 2.7-2.715 2.882l-.194.017-.195.006H9.104c-1.569 0-2.882-1.094-3.079-2.54l-.019-.183L6 23.595V9.725c0-1.477 1.178-2.7 2.715-2.882l.194-.018.195-.005 1.139-.001V5.492c0-.473.347-.864.808-.966l.117-.02.121-.006c.473 0 .883.3 1.01.741l.027.124.01.127-.001 1.327h2.858V5.463c0-.452.316-.828.74-.934l.12-.022.122-.007a.98.98 0 0 1 .941.697l.029.117.012.149-.002 1.356h2.859V5.492c0-.473.348-.864.808-.966l.117-.02.122-.006zm3.197 7.015H8.092v11.989c0 .473.328.877.764.983l.122.021.126.007h14.142c.476 0 .878-.33.983-.764l.021-.122.007-.125V11.515zm-7.883 1.614 1.085 2.516c.031.071.097.12.174.129l2.75.28c.187.02.26.253.118.377l-2.072 1.791a.214.214 0 0 0-.07.21l.613 2.73a.215.215 0 0 1-.321.23l-2.365-1.446a.214.214 0 0 0-.222 0L13.7 21.393a.215.215 0 0 1-.32-.232l.611-2.729a.215.215 0 0 0-.07-.21l-2.071-1.79a.215.215 0 0 1 .118-.377l2.75-.281a.212.212 0 0 0 .174-.129l1.085-2.516a.217.217 0 0 1 .397 0z"
                                      fill="var(--svg-color-secondary, #163435)"
                                    ></path>
                                  </g>
                                </svg>
                              </div>

                              <span
                                className="text-ellipsis whitespace-nowrap text-md custom-calender single-calender"
                                onClick={() =>
                                  setCalendarIsOpen(!calendarIsOpen)
                                }
                              >
                                <DatePicker
                                  selected={excludeDates.length == daysRange ? "" : startDate}
                                  onChange={onChangedate}
                                  excludeDates={isCalendarStatus === 1 || excludeDates.length === 0 ? [] : excludeDates}
                                  minDate={isCalendarStatus === 1 ? "" : minSelectableDate}
                                  // maxDate={isCalendarStatus === 1 ? addMonths(new Date(), 24) : addMonths(new Date(), 12)}
                                  maxDate={addDays(new Date(), 730)}
                                  renderDayContents={renderDayContents}
                                  dateFormat="dd/MM/yyyy"
                                  locale={i18n.resolvedLanguage}
                                  calendarStartDay={1}
                                  monthsShown={1}
                                  withPortal
                                  placeholderText={t("Rent.Whenever")}
                                  onFocus={(e) => {
                                    e.target.blur(); // Prevents keyboard from opening on iOS
                                    setTimeout(() => {
                                      e.target.readOnly = true; // Works for Android
                                    }, 0);
                                  }}
                                  ref={pickerRef}
                                  required
                                  onKeyDown={(e) => e.preventDefault()}
                                  renderCustomHeader={({
                                    date,
                                    decreaseMonth,
                                    increaseMonth,
                                    prevMonthButtonDisabled,
                                    nextMonthButtonDisabled,
                                  }) => {
                                    // Call the function we created in Step 2
                                    const info = getSeasonalInfo(date);

                                    // Dynamic Styles based on theme
                                    const bgClass = info.theme === "orange"
                                      ? "bg-orange-50 border-orange-200 text-orange-800"
                                      : "bg-blue-50 border-blue-200 text-blue-800";

                                    return (
                                      <div className="flex flex-col">
                                        {/* 1. Seasonal Banner */}
                                        <div className={`calender-banner mx-2 mt-2 mb-2 rounded-lg border px-2 py-1 shadow-sm ${bgClass}`}>
                                          <div className="flex items-center justify-center gap-2 text-xs font-bold">
                                            <span>{info.icon}</span>
                                            <span className="banner-season-title">{info.title}</span>
                                          </div>
                                          <hr />
                                          {/* 2. Instruction Text */}
                                          <div className="text-center text-xs text-gray-500 banner-season-title">
                                            {t("Rent.Start on your preferred date")}
                                          </div>
                                        </div>

                                        {/* 3. Navigation */}
                                        <div className="flex items-center justify-between px-2 custom-header mx-3">
                                          <button
                                            onClick={decreaseMonth}
                                            disabled={prevMonthButtonDisabled}
                                            type="button"
                                            className={`h-8 w-8 flex items-center justify-center rounded-full hover:bg-gray-100 ${prevMonthButtonDisabled ? 'opacity-50' : ''}`}
                                          >
                                            <span className="text-gray-600 font-bold">{<svg xmlns="http://www.w3.org/2000/svg" width="800px" height="800px" viewBox="0 0 24 24" fill="none">
                                              <path d="M15 6L9 12L15 18" stroke="#000000" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                            </svg>}</span>
                                          </button>

                                          <span className="text-lg font-bold text-gray-800">
                                            {moment(date).locale(i18n.resolvedLanguage).format("MMMM yyyy")}
                                          </span>

                                          <button
                                            onClick={increaseMonth}
                                            disabled={nextMonthButtonDisabled}
                                            type="button"
                                            className={`h-8 w-8 flex items-center justify-center rounded-full hover:bg-gray-100 ${nextMonthButtonDisabled ? 'opacity-50' : ''}`}
                                          >
                                            <span className="text-gray-600 font-bold">{<svg xmlns="http://www.w3.org/2000/svg" width="800px" height="800px" viewBox="0 0 24 24" fill="none">
                                              <path d="M9 6L15 12L9 18" stroke="#000000" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                            </svg>}</span>
                                          </button>
                                        </div>

                                        {/* 4. Dynamic Price */}
                                        <div className="text-center font-bold text-slate-800 mt-1 price-font">
                                            {info.price}€ / {t("subscription.Month")}
                                          </div>
                                      </div>
                                    );
                                  }}
                                >
                                  <div
                                    className="calender-status"
                                    style={{
                                      display: "flex",
                                      justifyContent: "center",
                                      gap: "0",
                                      padding: "15px",
                                      borderTop: "1px solid #ddd",
                                      marginTop: "5px",
                                    }}
                                  >
                                    <div className="max-w-md mb-3 mt-2">
                                      <div className="flex items-start gap-2 rounded-xl bg-blue-50 px-4 py-3 shadow-sm">
                                        {/* Icon */}
                                        <div className="flex h-8 w-8 items-center justify-center">
                                          <img
                                            className="h-5 w-5 text-yellow-400"
                                            src="/svg-icon/light-bulb-idea-svgrepo-com.svg"
                                            alt="Info Icon"
                                          />
                                        </div>

                                        {/* Text */}
                                        <p className="info-note text-sm text-gray-700 flex flex-wrap whitespace-normal text-start">
                                          {t("Rent.Monthly prices are prorated by day based on your start date.")}
                                        </p>
                                      </div>
                                    </div>

                                    <div
                                      style={{
                                        display: "flex",
                                        alignItems: "center",
                                        gap: "5px",
                                      }}
                                    >
                                      <span
                                        style={{
                                          width: "12px",
                                          height: "12px",
                                          backgroundColor: "white",
                                          border: "1px solid black",
                                          borderRadius: "50%",
                                        }}
                                      ></span>
                                      <span style={{ fontSize: "12px" }}>
                                        {t("Rent.Fully available")}
                                      </span>
                                    </div>
                                    <div
                                      style={{
                                        display: "flex",
                                        alignItems: "center",
                                        gap: "5px",
                                      }}
                                    >
                                      <span
                                        style={{
                                          width: "12px",
                                          height: "12px",
                                          backgroundColor: "red",
                                          borderRadius: "50%",
                                        }}
                                      ></span>
                                      <span style={{ fontSize: "12px" }}>
                                        {t("Rent.Vehicle not available")}
                                      </span>
                                    </div>
                                    <div
                                      style={{
                                        display: "flex",
                                        alignItems: "center",
                                        gap: "5px",
                                      }}
                                    >
                                      <span
                                        style={{
                                          width: "12px",
                                          height: "12px",
                                          backgroundColor: "orange",
                                          borderRadius: "50%",
                                        }}
                                      ></span>
                                      <span style={{ fontSize: "12px" }}>
                                        {t(
                                          "Rent.Pickup/return not possible, bookings are allowed"
                                        )}
                                      </span>
                                    </div>
                                  </div>
                                </DatePicker>
                              </span>
                              <div className="inline-block align-top ml-2 mr-4 min-w-fit transition-all child:h-6 child:w-6 dark:cssvar-secondary-to-off-white">
                                <svg width="32" height="32" viewBox="0 0 32 32">
                                  <g fill="none" fillRule="evenodd">
                                    <path
                                      d="m16 22.126 7.647-7.647c.47-.47.47-1.234 0-1.705l-.42-.42a1.204 1.204 0 0 0-1.705 0L16 17.876l-5.522-5.522a1.203 1.203 0 0 0-1.704 0l-.422.42c-.47.47-.469 1.235.002 1.705L16 22.126z"
                                      fill="var(--svg-color-secondary, #163435)"
                                    ></path>
                                  </g>
                                </svg>
                              </div>
                            </span>
                          </div>
                          {(errorStartDate && !startDate) ? (
                            <p
                              style={{ color: "red" }}
                              className="mb-2 mt-3 flex w-full animate-wiggle items-center justify-between rounded bg-warning px-4 py-2 text-lg text-white"
                            >
                              {errorStartDate}
                            </p>
                          ) : (
                            ""
                          )}

                          <h4 className="mt-3 mb-1">{t("Rent.Duration")}</h4>
                          <div className="w-full custom-pickup-return custom-months-select">
                            <div>
                              <span className="group outline-none">
                                <div className="relative flex items-center border-opacity-disabled  block w-full cursor-default">
                                  <div className="flex items-center justify-between w-full opacity-disabled">
                                    <svg
                                      className="watch  w-7 h-7"
                                      width="32"
                                      height="32"
                                      aria-hidden="true"
                                    >
                                      <svg
                                        viewBox="0 0 32 32"
                                        fill="none"
                                        id="icon-clock-pickup"
                                      >
                                        <path
                                          fillRule="evenodd"
                                          clipRule="evenodd"
                                          d="M16.0004 5C22.0659 5 27 9.93484 27 16.0005C27 22.0662 22.0659 27 16.0004 27C9.93476 27 5 22.0662 5 16.0005C5 9.93484 9.93476 5 16.0004 5ZM16.0003 7.5C11.3151 7.5 7.5 11.3152 7.5 16.0005C7.5 20.6856 11.3149 24.5 16.0003 24.5C20.6856 24.5 24.5 20.6857 24.5 16.0005C24.5 11.315 20.6854 7.5 16.0003 7.5ZM16.2214 8.62618C16.5932 8.62618 16.7491 8.9661 16.7562 9.15491L17.2087 15.5123L20.6275 19.6289C20.75 19.7731 20.8682 20.1356 20.5685 20.436C20.2671 20.7364 19.9044 20.6213 19.7601 20.4947L14.8275 17.0998C14.6903 16.9776 14.629 16.8032 14.6225 16.6184C14.5827 16.5205 14.5559 16.4134 14.5635 16.299L15.6858 9.15491C15.6977 8.9661 15.8488 8.62618 16.2214 8.62618ZM28 0L32 7H24L28 0Z"
                                          fill="var(--svg-custom-color, var(--svg-color-secondary, #163435))"
                                        ></path>
                                      </svg>
                                    </svg>
                                    {/* Duration */}
                                    <Select
                                      // autoFocus
                                      backspaceRemovesValue={false}
                                      hideSelectedOptions={false}
                                      tabSelectsValue={false}
                                      className="react-select-container w-full"
                                      classNamePrefix="react-select"
                                      options={monthoptions}
                                      onChange={handleMonth}
                                      isSearchable={false}
                                      value={monthselect}
                                      placeholder={t("Rent.Select a duration")}
                                      // formatOptionLabel={(option, { context }) => {
                                      //   if (context == 'menu') {
                                      //     return option.label;
                                      //   }
                                      //   return `${option.value} ${t("Rent.Months")}`;
                                      // }}
                                    />
                                    <svg
                                      className="down-arrow w-7 h-7"
                                      width="32"
                                      height="32"
                                      aria-hidden="true"
                                    >
                                      <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        viewBox="0 0 32 32"
                                        fill="none"
                                        id="icon-chevron-down"
                                      >
                                        <path
                                          fillRule="evenodd"
                                          clipRule="evenodd"
                                          d="M16.0001 22.1256L23.6467 14.479C24.1173 14.009 24.1179 13.2445 23.6479 12.7739L23.2266 12.3532C22.7542 11.8809 21.9927 11.8833 21.5215 12.3544L16.0001 17.8759L10.4781 12.3544C10.0075 11.8833 9.24543 11.8809 8.77364 12.3532L8.35234 12.7739C7.88175 13.2445 7.88296 14.009 8.35354 14.479L16.0001 22.1256Z"
                                          fill="var(--svg-custom-color, var(--svg-color-secondary, #163435))"
                                        ></path>
                                      </svg>
                                    </svg>
                                  </div>
                                </div>
                              </span>
                            </div>
                          </div>
                          {(errorMonthselect && !monthselect) ? (
                            <p
                              style={{ color: "red" }}
                              className="mb-2 mt-3 flex w-full animate-wiggle items-center justify-between rounded bg-warning px-4 py-2 text-lg text-white"
                            >
                              {errorMonthselect}
                            </p>
                          ) : (
                            ""
                          )}
                          
                          <div className="mt-4 w-full rounded bg-off-white p-5 text-left dark:bg-black">
                            {camper.inclusive &&
                              camper.inclusive.map((inclusive) => (
                                <div className="md:mb-4 mb-2 flex items-center last:mb-0">
                                  <div className="inline-flex items-center justify-center rounded-full border border-primary bg-white dark:border-primary-dark dark:bg-off-white mr-3 p-0">
                                    <div className="inline-block align-top child:h-6 child:w-6">
                                      <svg
                                        width="32"
                                        height="32"
                                        viewBox="0 0 32 32"
                                      >
                                        <g fill="none" fillRule="evenodd">
                                          <path
                                            d="m21.906 9.488-8.547 9.56-3.45-3.096a1.757 1.757 0 0 0-2.563.209c-.64.792-.547 1.98.21 2.659l4.764 4.274c.735.66 1.833.602 2.496-.13l9.73-10.869a1.954 1.954 0 0 0-.069-2.665 1.758 1.758 0 0 0-2.571.058z"
                                            fill="var(--svg-color-secondary, #163435)"
                                          ></path>
                                        </g>
                                      </svg>
                                    </div>
                                  </div>
                                  <p className="text-md">{inclusive.i_title}</p>
                                </div>
                              ))}
                          </div>

                          <div className="md:my-4 my-2 flex min-h-[70px] w-full flex-col justify-center 2xl:my-8">
                            
                            <div className="mb-1 text-xl text-primary dark:text-primary-light">
                              {/* {t("Rent.from")}{" "}
                              <NumericFormat
                                value={totalcamperprice}
                                thousandSeparator={"."}
                                decimalSeparator={","}
                                displayType={"text"}
                              />
                              € */}
                            </div>

                            <>
                              {/* <p className="text-xs mb-3">{t("subscription.first month")} </p> */}
                              {/* <p className="text-xs mb-3">{t("Rent.per Month")} </p> */}

                                <div className="max-w-full mb-5">
                                  <div className="flex items-center gap-2 rounded-xl bg-blue-50 px-4 py-3 shadow-sm">
                                    {/* Icon */}
                                    <div className="flex h-8 w-8 items-center justify-center">
                                      <img
                                        className="h-5 w-5 text-yellow-400"
                                        src="/svg-icon/lock.svg"
                                        alt="Info Icon"
                                      />
                                    </div>

                                    {/* Text */}
                                    <p className="info-note text-sm text-gray-700 flex flex-wrap whitespace-normal text-start">
                                      {t("Rent.Monthly payment.")}
                                      <br />
                                      {t("Rent.Full cost transparency from the start.")}
                                    </p>
                                  </div>
                                </div>

                              {error ? (
                                <p
                                  style={{ color: "red" }}
                                  className="mb-2 flex w-full animate-wiggle items-center justify-between rounded bg-warning px-4 py-2 text-lg text-white"
                                >
                                  {error}
                                </p>
                              ) : (
                                ""
                              )}
                                
                              {ExcludedateList.length == daysRange ? (
                                <>
                                  <p
                                    style={{ color: "red" }}
                                    className="mb-2 flex w-full animate-wiggle items-center justify-between rounded bg-warning px-4 py-2 text-lg text-white"
                                  >
                                    {t("rentinfo.Inventory is not available")}
                                  </p>
                                  <Link
                                    to="#"
                                    className="group/button block disabled:opacity-50 border border-transparent rounded text-md text-white dark:text-off-white bg-primary dark:bg-primary-dark p-3 pl-5 hover:bg-secondary group-hover/parent:bg-secondary dark:hover:text-off-black dark:group-hover/parent:text-off-black dark:hover:bg-off-white dark:group-hover/parent:bg-off-white transition-all shadow dark:shadow-dark hover:shadow-elevated dark:hover:shadow-dark-elevated w-full"
                                  >
                                    <div className="flex h-full items-center justify-between">
                                      <span className="flex">
                                        {t("rentinfo.Configure now")}
                                      </span>
                                      <div className="inline-block align-top min-w-max child:h-6 child:w-6 dark:cssvar-secondary-to-off-white ml-2 cssvar-secondary-to-white dark:group-hover/button:cssvar-secondary-to-off-black dark:group-hover/parent:cssvar-secondary-to-off-black">
                                        <svg
                                          width="32"
                                          height="32"
                                          viewBox="0 0 32 32"
                                        >
                                          <g fill="none" fillRule="evenodd">
                                            <path
                                              d="m22.126 16-7.647-7.647a1.207 1.207 0 0 0-1.705 0l-.42.42a1.204 1.204 0 0 0 0 1.705L17.876 16l-5.522 5.522a1.203 1.203 0 0 0 0 1.704l.42.422c.47.47 1.235.469 1.705-.002L22.126 16z"
                                              fill="var(--svg-color-secondary, #fff)"
                                            ></path>
                                          </g>
                                        </svg>
                                      </div>
                                    </div>
                                  </Link>{" "}

                                </>
                              ) : (
                                <Button
                                  onClick={(e) => handleCheckout(camper.id)}
                                  className="group/button block disabled:opacity-50 border border-transparent rounded text-md text-white dark:text-off-white bg-primary dark:bg-primary-dark p-3 pl-5 hover:bg-secondary group-hover/parent:bg-secondary dark:hover:text-off-black dark:group-hover/parent:text-off-black dark:hover:bg-off-white dark:group-hover/parent:bg-off-white transition-all shadow dark:shadow-dark hover:shadow-elevated dark:hover:shadow-dark-elevated w-full"
                                >
                                  <div className="flex h-full items-center justify-between">
                                    <span className="flex">{t("rentinfo.Configure now")}</span>
                                    <div className="inline-block align-top min-w-max child:h-6 child:w-6 dark:cssvar-secondary-to-off-white ml-2 cssvar-secondary-to-white dark:group-hover/button:cssvar-secondary-to-off-black dark:group-hover/parent:cssvar-secondary-to-off-black">
                                      <svg
                                        width="32"
                                        height="32"
                                        viewBox="0 0 32 32"
                                      >
                                        <g fill="none" fillRule="evenodd">
                                          <path
                                            d="m22.126 16-7.647-7.647a1.207 1.207 0 0 0-1.705 0l-.42.42a1.204 1.204 0 0 0 0 1.705L17.876 16l-5.522 5.522a1.203 1.203 0 0 0 0 1.704l.42.422c.47.47 1.235.469 1.705-.002L22.126 16z"
                                            fill="var(--svg-color-secondary, #fff)"
                                          ></path>
                                        </g>
                                      </svg>
                                    </div>
                                  </div>
                                </Button>
                              )}
                            </>
                          </div>
                        </form>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="relative  before:bg-white  mx-5 bg-transparent dark:bg-transparent lg:mx-auto xl:mx-auto">
                  <h1 className="hidden mobile-none whitespace-pre-line pt-12 pb-6 text-center text-xl md:pt-16 md:pb-9 md:text-2xl 2xl:text-3xl">
                    {camper.title}
                  </h1>
                  <div className="xl:pt-5 pt-8 pb-5 max-w-3xl m-auto">
                    <div className="bg-primary flex flex-col justify-center rounded-lg p-4 dark:bg-black sm:flex-row sm:px-6 sm:py-10">
                      {camper.feature &&
                        camper.feature.map((feature) => (
                          <div className="mb-4 flex items-center last:mb-0 sm:mx-2 sm:mb-0 sm:w-1/5 sm:flex-col">
                            <div className="inline-block align-top dark:cssvar-white-to-off-white dark:cssvar-secondary-to-secondary dark:cssvar-primary-to-primary-dark mr-3 child:h-12 child:w-12 sm:mr-0 sm:mb-3 sm:child:h-16 sm:child:w-16">
                              <img
                                className="white-img"
                                src={
                                  feature.icon
                                    ? process.env.REACT_APP_LARAVEL_IMAGE_URL +
                                    "Feature/" +
                                    feature.icon
                                    : ""
                                }
                              />
                            </div>
                            <p className="text-white fw-500 whitespace-pre-line text-md sm:text-center">
                              {feature.title}
                            </p>
                          </div>
                        ))}
                    </div>
                  </div>
                  {camper.camper_details &&
                    camper.camper_details.map((camper_details) => (
                      <div className="div">
                        <div className="pt-2 xl:pt-3 2xl:pt-3 pb-0 xl:pb-3 2xl:pb-0 text-left mx-auto max-w-3xl">
                          <div className="min-h-[30px] break-words text-sm 2xl:text-2md 2xl:font-normal">
                            <p
                              dangerouslySetInnerHTML={{
                                __html: camper_details.details,
                              }}
                            ></p>
                          </div>
                        </div>
                        <div className="pt-8 2xl:pt-8 xl:pb-3 pb-2 2xl:pb-0">
                          {/* <div className="relative mx-auto max-w-3xl">
                            <div className="mask-image relative h-0 w-full overflow-hidden rounded bg-off-white pt-[56.25%] shadow dark:bg-black dark:shadow-dark 2xs:rounded-lg">
                              <iframe
                                className="absolute top-0 left-0 aspect-video h-full w-full"
                                src={camper_details.video_url}
                                frameborder="0"
                              ></iframe>
                            </div>
                          </div> */}
                          <div className="relative mx-auto max-w-3xl">
                            <YouTubeFacade
                              videoUrl={camper_details?.video_url}
                              title={camper_details?.title || "Camper video"}
                            />
                          </div>
                        </div>
                      </div>
                    ))}
                </div>

                <div className="mx-5 mb-8 lg:mx-auto xl:mx-auto">
                  <div className="pt-8 2xl:pt-12 xl:pb-4 pb-1 2xl:pb-0">
                    <Camperdetails />
                  </div>
                  {camper.pdf_url != null ? (
                    <div className="pt-8 2xl:pt-12 pb-8 2xl:pb-0">
                      <div className="overflow-hidden rounded bg-white  p-4 shadow dark:bg-off-black-desat dark:shadow-dark 2xs:rounded-lg mx-auto flex max-w-3xl flex-col items-center md:p-8 2xl:p-16">
                        <svg
                          width="90"
                          height="90"
                          viewBox="0 0 128 128"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M43.1074 51.8946H86.0085C88.1058 51.8946 89.7911 50.1906 89.7911 48.1121V25.0978C89.7911 23.0005 88.5178 21.8957 86.0085 21.5024L75.3347 20.3414C68.7057 19.7422 62.0393 19.7234 55.4103 20.2665L43.1074 21.4837C40.7292 21.8395 39.3247 23.0005 39.3247 25.0791V48.0933C39.3247 50.1906 41.0288 51.8759 43.1074 51.8759V51.8946Z"
                            fill="var(--svg-color-primary, #EE7214)"
                          ></path>
                          <path
                            d="M45.373 66.5757L46.7775 66.5382L48.1819 66.557L48.2568 60.4335L48.1819 56.7258L48.4628 55.9019L48.1819 53.8795V52.2691L48.7063 51.6511L48.1819 49.8347V49.1606H48.0321L47.77 47.9434L46.1595 47.6438L45.785 48.5051L46.1221 50.153L45.373 51.2204L45.7476 51.2391L45.579 54.048V55.6397L45.4479 56.0705L45.373 56.2952L45.3918 57.1378L45.2419 59.6283L45.373 66.5757Z"
                            fill="var(--svg-color-secondary, #EE7214)"
                          ></path>
                          <path
                            d="M82.1506 66.4822L82.0008 62.4561L82.1506 62.4186V60.5835L82.0944 57.3439L81.9633 52.9433V52.8684V52.7373L81.9071 52.2879L81.8135 51.3328L82.0195 47.2506L80.9521 47.5689L79.7724 47.1195L79.6226 50.2093L79.3417 50.228L79.66 52.4564L79.7162 52.9059L79.3417 57.4936V60.1714L79.1169 60.2277L79.3417 66.5945L82.1506 66.4822Z"
                            fill="var(--svg-color-secondary, #EE7214)"
                          ></path>
                          <path
                            d="M32.2273 65.5083L31.8528 65.0963V63.0927L31.834 63.074V62.9802L31.6468 60.8081L32.04 55.8831L31.1037 55.8083V55.7708H30.7105L29.2311 55.6584V55.7708H28.2948L28.2761 61.0328L29.0439 63.336V66.2387L29.9802 67.2123L30.8229 68.4108L35.2983 72.6429L37.2271 70.5831L33.0512 66.6881L32.2273 65.5083Z"
                            fill="var(--svg-color-secondary, #EE7214)"
                          ></path>
                          <path
                            d="M89.0979 103.803C88.7233 103.241 88.199 103.147 87.7496 103.185C86.3639 102.455 84.6224 101.481 82.8059 100.264C82.4501 100.02 82.0569 99.6457 81.6262 99.2524C81.1019 98.7468 80.5401 98.2412 79.9034 97.8105C79.454 97.5109 78.705 96.8742 77.9746 96.2375C77.132 95.5072 76.2519 94.7582 75.6152 94.3275L74.6602 93.7095L74.2669 94.0653L71.0648 91.9305C71.0648 91.9305 70.9899 91.8744 70.9712 91.8557L71.0273 91.7807C70.8401 91.6122 69.9038 90.6385 69.3046 89.7209C69.2484 89.646 69.2484 89.5711 69.2484 89.2902V89.028C69.2484 88.9157 69.2484 88.822 69.2109 88.6722C69.7727 87.9606 70.7839 87.1367 71.1584 86.8745L71.0086 86.6685C71.3082 86.6685 71.5704 86.5562 71.87 86.3502C72.9374 85.6386 74.8849 84.1967 75.9148 83.2604C80.3903 80.2643 83.5175 78.1857 83.7422 78.0359L82.9932 76.8374V75.433C82.9932 75.433 82.8247 75.433 82.6936 75.4892C81.6075 75.7326 78.2181 77.1932 74.1733 81.032C73.6677 81.3878 72.9935 81.9122 72.3007 82.4739C71.7576 82.9046 71.1959 83.354 70.7277 83.7098C70.3719 83.6536 70.0161 83.8034 69.6604 84.0469L67.5443 85.4513C66.6455 86.0505 65.7466 86.6872 64.8478 87.3239C63.9489 86.7621 62.9752 86.2378 62.0202 85.7322C60.9902 85.2079 60.0352 84.7023 59.2487 84.178C58.1813 83.4664 56.3837 82.0432 54.6421 80.6575C53.0317 79.3841 51.5149 78.167 50.6535 77.6052C47.0394 75.1896 46.2529 75.1896 45.56 75.4517L44.6425 76.4816L46.0095 76.8187V76.8562L45.2604 78.0172C45.4477 78.1482 47.9757 79.8148 51.7022 82.3241C52.5074 82.8672 53.4062 83.5038 54.3612 84.1967C55.4286 84.9645 56.5522 85.7884 57.6757 86.5374C58.2375 86.912 58.8555 87.2678 59.4922 87.6048L60.6719 88.9718L60.4472 89.4774L60.6719 90.0018L59.642 91.1441C58.6495 91.8557 57.657 92.5485 56.6645 93.2226C56.4773 93.3537 56.1402 93.4848 55.8031 93.5972C55.3537 93.7657 54.8481 93.9529 54.3987 94.2525C53.4249 94.9079 52.1141 95.6944 50.822 96.4809C49.5674 97.23 48.3502 97.9791 47.5076 98.5408C46.2904 99.3648 45.6162 99.8891 44.9608 100.413C44.5301 100.769 44.0994 101.106 43.4815 101.537C38.7438 104.87 38.6876 104.926 38.594 105.02L40.4292 107.136C40.4292 107.136 40.5977 107.024 40.9909 106.724C41.122 106.762 41.2531 106.78 41.3842 106.78C42.3392 106.78 43.3129 105.788 44.3241 104.777C44.3803 104.72 44.605 104.627 44.7548 104.552C45.0545 104.421 45.4103 104.271 45.7848 104.009C46.0095 103.84 46.2342 103.597 46.3278 103.185C46.4027 103.147 46.4589 103.091 46.5338 103.054C46.8896 102.81 47.2641 102.586 47.6574 102.323C48.1255 102.024 48.6311 101.706 49.1367 101.35C49.9794 100.788 51.1591 99.9452 52.3763 99.0651C53.6497 98.1663 54.9605 97.2299 55.9342 96.5745C56.1215 96.4434 56.4586 96.3312 56.7769 96.2001C57.2263 96.0316 57.7506 95.8442 58.2001 95.5259C59.2674 94.8143 60.3161 94.0653 61.3835 93.335L61.4209 93.2975C62.2261 92.7357 63.0126 92.2115 63.8178 91.6497C64.2111 91.3688 64.5856 91.1253 64.9789 90.8444C65.3908 91.144 65.8028 91.4624 66.196 91.7621C66.2897 91.837 66.402 91.9119 66.4957 91.9868C66.9638 92.3426 67.4319 92.717 67.9375 93.0915C67.9375 93.0915 67.975 93.1103 67.975 93.129C68.4431 93.4848 68.9487 93.8406 69.4918 94.1964L72.2633 96.0503L73.0123 96.5372L75.2594 98.0352L75.3343 97.9603C75.6339 98.2412 75.9523 98.5596 76.2893 98.8779C77.0009 99.5895 77.675 100.264 78.3117 100.676C78.8173 101.013 79.3042 101.331 79.9034 101.687C80.3528 101.968 80.8023 102.249 81.233 102.529C81.439 102.661 81.7573 102.998 82.0195 103.278C82.394 103.653 82.7685 104.065 83.1805 104.327C83.6112 104.608 84.0044 104.702 84.3227 104.739C84.4351 104.926 84.5849 105.114 84.8096 105.245C85.2403 105.526 85.6336 105.638 85.8957 105.713C85.9706 105.732 86.0268 105.75 86.083 105.769C86.1204 105.788 86.1392 105.806 86.1766 105.825C86.2328 106.406 86.626 106.743 86.8508 106.893C87.0755 107.042 87.3564 107.192 87.6747 107.305C88.3863 107.567 89.0792 107.623 89.1728 107.623L89.229 106.949C89.4162 107.024 89.5473 107.08 89.566 107.099L90.6521 104.514C90.6521 104.514 90.0716 104.271 89.1353 103.822C89.1353 103.803 89.1353 103.765 89.0979 103.747V103.803ZM42.6763 105.582H42.6575C42.6575 105.582 42.6763 105.563 42.695 105.544C42.695 105.544 42.695 105.563 42.695 105.582H42.6763Z"
                            fill="var(--svg-color-secondary, #EE7214)"
                          ></path>
                          <path
                            d="M100.371 62.4372L100.858 55.8831L99.7528 55.7895L99.7341 55.5648L98.7042 55.7147L98.0675 55.6584L98.0488 55.8083L96.9439 55.9767L97.6742 60.8643L97.5244 62.8118L97.8428 63.7293L95.8953 66.5569L91.8879 70.6204L93.9103 72.5866L97.9739 68.4295L100.97 64.16L100.371 62.4372Z"
                            fill="var(--svg-color-secondary, #EE7214)"
                          ></path>
                          <path
                            d="M38.8937 53.0182C38.8937 50.6025 36.9275 48.6362 34.5118 48.6362H26.1226C23.707 48.6362 21.7407 50.6025 21.7407 53.0182C21.7407 55.4338 23.707 57.4 26.1226 57.4H34.5118C36.9275 57.4 38.8937 55.4338 38.8937 53.0182Z"
                            fill="var(--svg-color-primary, #EE7214)"
                          ></path>
                          <path
                            d="M102.693 48.6362H94.8655C92.4499 48.6362 90.4836 50.6025 90.4836 53.0182C90.4836 55.4338 92.4499 57.4 94.8655 57.4H102.693C105.109 57.4 107.075 55.4338 107.075 53.0182C107.075 50.6025 105.109 48.6362 102.693 48.6362Z"
                            fill="var(--svg-color-primary, #EE7214)"
                          ></path>
                          <path
                            d="M91.8881 63.074C91.3825 61.295 89.847 60.2463 88.3114 60.5834C75.4093 63.411 51.3277 62.6619 41.1783 59.7032C39.6615 59.2538 38.0885 60.1714 37.4892 61.913L32.6954 70.3958C32.0213 72.362 32.9388 74.9837 34.6616 75.4705C44.3055 78.2045 54.792 79.7587 65.6156 79.7587C74.9224 79.7587 84.4914 78.5603 94.0041 76.5379C95.7457 76.1634 96.7943 73.6166 96.2138 71.5942L91.9068 63.0552L91.8881 63.074Z"
                            fill="var(--svg-color-primary, #EE7214)"
                          ></path>
                        </svg>
                        <p className="mb-5 whitespace-pre-line text-center text-lg md:text-xl">
                          {t("rentinfo.Fully equipped for")} {t("rentinfo.Adventure")}
                        </p>

                        <a
                          className="button-padding-sm group/button block border border-transparent rounded text-md text-white dark:text-off-white button-primary-bg dark:bg-primary-dark p-3 pl-5 hover:bg-secondary group-hover/parent:bg-secondary dark:hover:text-off-black dark:group-hover/parent:text-off-black dark:hover:bg-off-white dark:group-hover/parent:bg-off-white transition-all shadow dark:shadow-dark hover:shadow-elevated dark:hover:shadow-dark-elevated col-span-2 disabled:opacity-100 sm:col-span-1 text-lg text-center"
                          href={imageUrl + camper.pdf_url}
                          target="_blank"
                        >
                          <div className="flex h-full items-center justify-between">
                            <div className="inline-block align-top mr-2 rounded-full bg-white p-1 child:h-7 child:w-7 dark:bg-off-white">
                              <svg
                                width="32px"
                                height="32px"
                                viewBox="0 0 32 32"
                                version="1.1"
                              >
                                <title>icon/vehicles_camper</title>
                                <g
                                  id="icon/vehicles_camper"
                                  stroke="none"
                                  strokeWidth="1"
                                  fill="none"
                                  fillRule="evenodd"
                                >
                                  <path
                                    d="M25.6867041,10.0937063 C27.1799243,10.49525 27.6,11.4612038 27.6,12.3467595 L27.6,21.2178687 C27.6,22.5979678 26.5476831,23.7322647 25.201696,23.8622002 C25.1072216,24.2651377 24.9020342,24.6338756 24.6075905,24.9283193 C24.1930404,25.3428693 23.6312217,25.5804986 23.033099,25.5804986 C22.4349432,25.5804986 21.8731023,25.342877 21.4585378,24.9283294 C21.1672744,24.6370781 20.9633474,24.2731307 20.8678096,23.8749636 L11.0804377,23.8749576 C10.9849029,24.2731207 10.7809823,24.6370664 10.4897293,24.9283193 C10.0751793,25.3428693 9.51336054,25.5804986 8.91523783,25.5804986 C8.3170821,25.5804986 7.75524116,25.342877 7.3406766,24.9283294 C7.04941331,24.6370781 6.84548626,24.2731307 6.74994852,23.8749636 L6.25664951,23.8746095 C4.78940367,23.8746095 3.6,22.6851707 3.6,21.2178687 L3.6,19.8762457 C3.6,18.2384938 5.12518583,16.6834565 6.76293768,16.6834565 C7.12097202,16.6834565 7.44776766,16.4794173 7.60493968,16.1577425 C8.22176481,15.0168328 8.75800502,14.0330239 9.21366032,13.2063157 C9.89714326,11.9662534 10.4897293,11.3467595 12.1614641,11.3467595 C13.7465711,9.63105678 13.6752718,7.56850889 12.9527919,6.21438809 C13.3167673,5.63433771 13.5640362,5.51205939 14.4125438,5.75132171 C15.7334216,6.12378306 19.491475,7.57124458 25.6867041,10.0937063 Z M8.91523783,22.1687205 C8.59614217,22.1687205 8.29831418,22.2946822 8.07714303,22.5158442 C7.85598464,22.7369935 7.73002864,23.0347802 7.73002864,23.3538385 C7.73002864,23.6728968 7.85598465,23.9706835 8.07714301,24.1918327 C8.29831418,24.4129948 8.59614217,24.5389565 8.91523783,24.5389565 C9.23428708,24.5389565 9.53208856,24.4129971 9.7532478,24.1918378 C9.97440136,23.9706843 10.1003558,23.6728951 10.1003558,23.3538385 C10.1003558,23.0347819 9.97440136,22.7369928 9.7532478,22.5158392 C9.53208856,22.2946799 9.23428708,22.1687205 8.91523783,22.1687205 Z M23.033099,22.1687205 C22.7140033,22.1687205 22.4161753,22.2946822 22.1950042,22.5158443 C21.9738457,22.7369935 21.8478898,23.0347802 21.8478898,23.3538385 C21.8478898,23.6728968 21.9738457,23.9706835 22.1950042,24.1918327 C22.4161753,24.4129948 22.7140033,24.5389565 23.033099,24.5389565 C23.3521482,24.5389565 23.6499497,24.4129971 23.8711089,24.1918378 C24.0922625,23.9706843 24.2182169,23.6728951 24.2182169,23.3538385 C24.2182169,23.0347819 24.0922625,22.7369928 23.8711089,22.5158392 C23.6499497,22.2946799 23.3521482,22.1687205 23.033099,22.1687205 Z M6.29651027,18.2111557 C5.96353891,18.0899942 5.5347965,18.4284223 5.33868862,18.96719 C5.14258073,19.5058463 5.25360831,20.0408278 5.58646832,20.1619893 C5.91943969,20.2831508 6.34818209,19.9446113 6.54428997,19.4059549 C6.74039786,18.8672986 6.62937028,18.3323171 6.29651027,18.2111557 Z M24.4923799,13.2870015 L15.461895,13.2870015 C15.2535719,13.2870015 15.0652933,13.4111514 14.9832308,13.6026305 L13.5561873,16.6323992 L23.9716088,16.6323992 C24.5468366,16.6323992 25.0131509,16.1660849 25.0131509,15.5908571 L25.0131509,13.8077725 C25.0131509,13.5201586 24.7799938,13.2870015 24.4923799,13.2870015 Z M13.4934461,13.2870015 L10.267021,13.2870015 L8.77300756,16.1953176 C8.69729947,16.3426945 8.75539851,16.5235406 8.9027754,16.5992487 C8.94518575,16.621035 8.99217806,16.6323992 9.03985702,16.6323992 L12.3260181,16.6323992 L12.3260181,16.6323992 L13.7327791,13.6499585 C13.7466699,13.6175465 13.7538321,13.5826507 13.7538321,13.5473875 C13.7538321,13.4035806 13.6372531,13.2870015 13.4934461,13.2870015 Z"
                                    id="Combined-Shape-Copy-3"
                                    fill="var(--svg-color-secondary, #163435)"
                                  ></path>
                                </g>
                              </svg>
                            </div>
                            <span className="flex">
                              {t("rentinfo.Equipment list")}  {camper.title}
                            </span>
                            <div className="inline-block align-top min-w-max child:h-6 child:w-6 dark:cssvar-secondary-to-off-white ml-2 cssvar-secondary-to-white dark:group-hover/button:cssvar-secondary-to-off-black dark:group-hover/parent:cssvar-secondary-to-off-black">
                              <svg
                                width="32"
                                height="32"
                                viewBox="0 0 32 32"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <g fill="none" fillRule="evenodd">
                                  <path
                                    d="m16 18.126 7.647-7.647c.47-.47.47-1.234 0-1.705l-.42-.42a1.204 1.204 0 0 0-1.705 0L16 13.876l-5.522-5.522a1.203 1.203 0 0 0-1.704 0l-.422.42c-.47.47-.469 1.235.002 1.705L16 18.126zm-8.143 3.207h16.286c.336 0 .516.047.679.134.163.087.29.215.378.378.087.163.133.343.133.679v.286c0 .335-.046.515-.133.678a.909.909 0 0 1-.378.378c-.163.088-.343.134-.679.134H7.857c-.336 0-.516-.046-.679-.134a.909.909 0 0 1-.378-.378c-.087-.163-.133-.343-.133-.678v-.286c0-.336.046-.516.133-.68a.909.909 0 0 1 .378-.377c.163-.087.343-.134.679-.134z"
                                    fill="var(--svg-color-secondary, #fff)"
                                  ></path>
                                </g>
                              </svg>
                            </div>
                          </div>
                        </a>
                      </div>
                    </div>
                  ) : (
                    ""
                  )}
                  <div className="md:pt-4 pt-0 2xl:pt-12 pb-8 2xl:pb-0">
                    {camper.technical &&
                      camper.technical.map((technical) => (
                        <div className="overflow-hidden rounded bg-white shadow dark:bg-off-black-desat dark:shadow-dark 2xs:rounded-lg sm:rounded-lg md:rounded-lg p-0">
                          <details className="group" close>
                            <summary className="flex cursor-pointer select-none items-center justify-between p-4 md:p-8">
                              <div className="inline-flex items-center justify-center rounded-full border bg-white p-1 dark:border-primary-dark dark:bg-off-white mr-4 border-warning-alternative">
                                <div className="inline-block align-top child:h-7 child:w-7">
                                  <svg
                                    className="no-rotate"
                                    width="32px"
                                    height="32px"
                                    viewBox="0 0 32 32"
                                    version="1.1"
                                  >
                                    <title>
                                      icon_technical_multifunktion-lenkrad_steering-wheel
                                    </title>
                                    <g
                                      id="icon_technical_multifunktion-lenkrad_steering-wheel"
                                      stroke="none"
                                      strokeWidth="1"
                                      fill="none"
                                      fillRule="evenodd"
                                    >
                                      <path
                                        d="M15.9995123,27 C22.0751036,27 27,22.0751036 27,15.9990246 C27,9.92440868 22.0751036,5 15.9995123,5 C9.92392099,5 5,9.92440868 5,15.9990246 C4.99975616,22.0751036 9.92392099,27 15.9995123,27 Z M13.215801,16.2518898 C13.215801,14.7204421 14.456852,13.4781761 15.9900008,13.4781761 C17.5224205,13.4781761 18.7642005,14.7201991 18.7642005,16.2518898 C18.7642005,17.7845525 17.5226635,19.0256035 15.9900008,19.0256035 C14.456852,19.0256035 13.215801,17.7845525 13.215801,16.2518898 Z M17.0495001,24.8473543 C17.8310168,21.2682273 20.8841746,18.5418191 24.6227749,18.253109 C23.7103146,21.754694 20.7217752,24.4159961 17.0495001,24.8473543 Z M15.9995123,7.08900268 C20.5218239,7.08900268 24.2543282,10.4584248 24.8310168,14.8234577 C21.9300171,14.2460376 19.6593514,10.9041697 15.9995123,10.9041697 C12.2874909,10.9041697 10.5584004,14.3413802 7.16508169,14.8451597 C7.7315289,10.4698854 11.4696416,7.08900268 15.9995123,7.08900268 Z M14.8239454,24.8312607 C11.2133626,24.355523 8.28505243,21.7207998 7.3796635,18.2645696 C11.0553524,18.6022921 14.0468178,21.3001707 14.8239454,24.8312607 Z"
                                        id="Shape"
                                        fill="var(--svg-color-secondary, #163435)"
                                      ></path>
                                    </g>
                                  </svg>
                                </div>
                              </div>
                              <h3 className="overflow-hidden text-ellipsis text-lg">
                                {t("rentinfo.Technical details")}
                              </h3>
                              <div className="inline-block align-top pl-4 child:h-8 child:w-8 child:transition-all group-open:child:rotate-180 dark:cssvar-secondary-to-off-white md:pl-6">
                                <svg width="32" height="32" viewBox="0 0 32 32">
                                  <g fill="none" fillRule="evenodd">
                                    <path
                                      d="m16 22.126 7.647-7.647c.47-.47.47-1.234 0-1.705l-.42-.42a1.204 1.204 0 0 0-1.705 0L16 17.876l-5.522-5.522a1.203 1.203 0 0 0-1.704 0l-.422.42c-.47.47-.469 1.235.002 1.705L16 22.126z"
                                      fill="var(--svg-color-secondary, #163435)"
                                    ></path>
                                  </g>
                                </svg>
                              </div>
                            </summary>

                            <div className="mb-5 px-5 md:mb-9 md:px-9">
                              <hr className="my-5 h-[3px] rounded border-none bg-grey dark:bg-grey-dark mt-0" />
                              <div className="my-5 sm:mx-8 lg:mx-0 xl:mx-8">
                                <div>
                                  <div className="flex flex-col justify-between sm:flex-row">
                                    <p className="mb-1 whitespace-pre-line text-md sm:mb-0">
                                      {t("rentinfo.Model")}
                                    </p>
                                    <p className="whitespace-pre-line sm:text-right">
                                      {technical.model}
                                    </p>
                                  </div>
                                  <hr className="h-[3px] rounded border-none bg-grey dark:bg-grey-dark my-3" />
                                </div>
                                <div>
                                  <div className="flex flex-col justify-between sm:flex-row">
                                    <p className="mb-1 whitespace-pre-line text-md sm:mb-0">
                                      {t("rentinfo.Fuel type")}
                                    </p>
                                    <p className="whitespace-pre-line sm:text-right">
                                      {technical.fuel.title}
                                    </p>
                                  </div>
                                  <hr className="h-[3px] rounded border-none bg-grey dark:bg-grey-dark my-3" />
                                </div>

                                <div>
                                  <div className="flex flex-col justify-between sm:flex-row">
                                    <p className="mb-1 whitespace-pre-line text-md sm:mb-0">
                                      {t("rentinfo.Brand")}
                                    </p>
                                    <p className="whitespace-pre-line sm:text-right">
                                      {technical.brands.title}
                                    </p>
                                  </div>
                                  <hr className="h-[3px] rounded border-none bg-grey dark:bg-grey-dark my-3" />
                                </div>
                                <div>
                                  <div className="flex flex-col justify-between sm:flex-row">
                                    <p className="mb-1 whitespace-pre-line text-md sm:mb-0">
                                      {t("rentinfo.Year of manufacture")}
                                    </p>
                                    <p className="whitespace-pre-line sm:text-right">
                                      {technical.year}
                                    </p>
                                  </div>
                                  <hr className="h-[3px] rounded border-none bg-grey dark:bg-grey-dark my-3" />
                                </div>
                                <div>
                                  <div className="flex flex-col justify-between sm:flex-row">
                                    <p className="mb-1 whitespace-pre-line text-md sm:mb-0">
                                      {t("rentinfo.Power")}
                                    </p>
                                    <p className="whitespace-pre-line sm:text-right">
                                      {technical.power}
                                    </p>
                                  </div>
                                  <hr className="h-[3px] rounded border-none bg-grey dark:bg-grey-dark my-3" />
                                </div>
                                <div>
                                  <div className="flex flex-col justify-between sm:flex-row">
                                    <p className="mb-1 whitespace-pre-line text-md sm:mb-0">
                                      {t("rentinfo.Displacement")}
                                    </p>
                                    <p className="whitespace-pre-line sm:text-right">
                                      {technical.cc}
                                    </p>
                                  </div>
                                  <hr className="h-[3px] rounded border-none bg-grey dark:bg-grey-dark my-3" />
                                </div>

                                <div>
                                  <div className="flex flex-col justify-between sm:flex-row">
                                    <p className="mb-1 whitespace-pre-line text-md sm:mb-0">
                                      Chassis
                                    </p>
                                    <p className="whitespace-pre-line sm:text-right">
                                      {technical.milage}
                                    </p>
                                  </div>
                                  <hr className="h-[3px] rounded border-none bg-grey dark:bg-grey-dark my-3" />
                                </div>
                                <div>
                                  <div className="flex flex-col justify-between sm:flex-row">
                                    <p className="mb-1 whitespace-pre-line text-md sm:mb-0">
                                      {t("rentinfo.Emission Standard")}
                                    </p>
                                    <p className="whitespace-pre-line sm:text-right">
                                      {technical.ees}
                                    </p>
                                  </div>
                                  <hr className="h-[3px] rounded border-none bg-grey dark:bg-grey-dark my-3" />
                                </div>
                                <div>
                                  <div className="flex flex-col justify-between sm:flex-row">
                                    <p className="mb-1 whitespace-pre-line text-md sm:mb-0">
                                      {t("rentinfo.Fuel consumption per 100 km")}
                                    </p>
                                    <p className="whitespace-pre-line sm:text-right">
                                      {technical.cpkm}
                                    </p>
                                  </div>
                                  <hr className="h-[3px] rounded border-none bg-grey dark:bg-grey-dark my-3" />
                                </div>
                                <div>
                                  <div className="flex flex-col justify-between sm:flex-row">
                                    <p className="mb-1 whitespace-pre-line text-md sm:mb-0">
                                      {t("rentinfo.Fuel tank")}
                                    </p>
                                    <p className="whitespace-pre-line sm:text-right">
                                      {technical.fueltank}
                                    </p>
                                  </div>
                                  <hr className="h-[3px] rounded border-none bg-grey dark:bg-grey-dark my-3" />
                                </div>
                                <div>
                                  <div className="flex flex-col justify-between sm:flex-row">
                                    <p className="mb-1 whitespace-pre-line text-md sm:mb-0">
                                      {t("rentinfo.Vehicle dimensions (length / width / height)")}
                                    </p>
                                    <p className="whitespace-pre-line sm:text-right">
                                      {technical.dimentions}
                                    </p>
                                  </div>
                                  <hr className="h-[3px] rounded border-none bg-grey dark:bg-grey-dark my-3" />
                                </div>
                                <div>
                                  <div className="flex flex-col justify-between sm:flex-row">
                                    <p className="mb-1 whitespace-pre-line text-md sm:mb-0">
                                      {t("rentinfo.Vehicle age")}
                                    </p>
                                    <p className="whitespace-pre-line sm:text-right">
                                      {technical.ferry}
                                    </p>
                                  </div>
                                  <hr className="h-[3px] rounded border-none bg-grey dark:bg-grey-dark my-3" />
                                </div>
                                <div>
                                  <div className="flex flex-col justify-between sm:flex-row">
                                    <p className="mb-1 whitespace-pre-line text-md sm:mb-0">
                                      {t("rentinfo.Length including bike rack for ferry booking")}
                                    </p>
                                    <p className="whitespace-pre-line sm:text-right">
                                      {technical.bike}
                                    </p>
                                  </div>
                                  <hr className="h-[3px] rounded border-none bg-grey dark:bg-grey-dark my-3" />
                                </div>
                                <div>
                                  <div className="flex flex-col justify-between sm:flex-row">
                                    <p className="mb-1 whitespace-pre-line text-md sm:mb-0">
                                      {t("rentinfo.Maximum permissible weight")}
                                    </p>
                                    <p className="whitespace-pre-line sm:text-right">
                                      {technical.weight}
                                    </p>
                                  </div>
                                  <hr className="h-[3px] rounded border-none bg-grey dark:bg-grey-dark my-3" />
                                </div>
                                <div>
                                  <div className="flex flex-col justify-between sm:flex-row">
                                    <p className="mb-1 whitespace-pre-line text-md sm:mb-0">
                                      {t("rentinfo.Weight in road-ready condition (+/- 5 %)")}
                                    </p>
                                    <p className="whitespace-pre-line sm:text-right">
                                      {technical.weight_condition}
                                    </p>
                                  </div>
                                  <hr className="h-[3px] rounded border-none bg-grey dark:bg-grey-dark my-3" />
                                </div>
                                <div>
                                  <div className="flex flex-col justify-between sm:flex-row">
                                    <p className="mb-1 whitespace-pre-line text-md sm:mb-0">
                                      {t("rentinfo.Trailer load (unbraked/braked)")}
                                    </p>
                                    <p className="whitespace-pre-line sm:text-right">
                                      {technical.trailer_load}
                                    </p>
                                  </div>
                                  <hr className="h-[3px] rounded border-none bg-grey dark:bg-grey-dark my-3" />
                                </div>
                                <div>
                                  <div className="flex flex-col justify-between sm:flex-row">
                                    <p className="flex-1 mb-1 whitespace-pre-line text-md sm:mb-0">
                                      {t("rentinfo.Driving assistance")
                                      }
                                    </p>
                                    <p className="flex-1 whitespace-pre-line sm:text-right">
                                      {technical.driving_assistance}
                                    </p>
                                  </div>
                                  <hr className="h-[3px] rounded border-none bg-grey dark:bg-grey-dark my-3" />
                                </div>
                              </div>
                            </div>
                          </details>
                        </div>
                      ))}
                  </div>

                  <div className="pt-8 2xl:pt-12 pb-8 2xl:pb-0">
                    <div className="overflow-hidden rounded bg-white shadow dark:bg-off-black-desat dark:shadow-dark 2xs:rounded-lg group/parent mask-image relative p-0 md:flex md:min-h-[400px] md:rounded-xl md:bg-transparent dark:md:bg-transparent justify-end">
                      <Link className="w-full md:flex" to={"/explanatoryvideo"}>
                        <div className="md:hidden">
                          <div className="overflow-hidden">
                            <div className="-ml-[5%] w-[110%] overflow-hidden rounded-b-[60%20%] px-[5%]">
                              <div className="relative">
                                <picture className="text-0">
                                  <img
                                    className="sm-h-20 inline-block max-w-full object-cover dark:brightness-90 max-h-[40vh] w-full group-hover/parent:scale-110 transition-all duration-300"
                                    src="../Images/video.jpg"
                                    alt="video_teaser"
                                  />
                                </picture>
                              </div>
                            </div>
                          </div>
                        </div>
                        <picture className="text-0 absolute top-0 left-0 z-background hidden h-full w-full transition-all duration-300 group-hover/parent:scale-105 md:block md:group-hover/parent:scale-[103%]">
                          <img
                            className="inline-block max-w-full object-cover dark:brightness-90 h-full w-full"
                            src="../Images/video.jpg"
                            alt="video_teaser"
                          />
                        </picture>
                        <div className="relative -mt-10 mb-4 flex justify-center xs:mb-4 md:hidden">
                          <div className="inline-block align-top dark:cssvar-white-to-off-white dark:cssvar-secondary-to-secondary dark:cssvar-primary-to-primary-dark child:h-20 child:w-20">
                            <img
                              src="../Images/img-youtube-icon.svg"
                              alt="youtube-icon"
                            />
                          </div>
                        </div>
                        <div className="z-0 m-6 mt-0 flex flex-col text-center xs:mt-0 md:m-5 md:mt-5 md:min-h-[calc(100%-theme(spacing.5)*2)] md:w-full md:max-w-1/2 md:rounded-lg md:bg-white md:p-8 md:text-left md:shadow md:dark:bg-off-black-desat xl:max-w-[45%] 2xl:m-9 2xl:mt-9 2xl:min-h-[calc(100%-theme(spacing.9)*2)]">
                          <div className="md:mb-6 mb-2 flex items-center justify-center md:justify-start">
                            <div className="relative mr-4 hidden md:block">
                              <div className="inline-block align-top dark:cssvar-white-to-off-white dark:cssvar-secondary-to-secondary dark:cssvar-primary-to-primary-dark child:h-16 child:w-16">
                                <img
                                  src="../Images/img-youtube-icon.svg"
                                  alt="youtube-icon"
                                />
                              </div>
                            </div>
                            <p className="text-lg small-lg">{t("Contact.Camper Secrets Revealed")}</p>
                          </div>
                          <h2 className="whitespace-pre-line break-words mb-2 md:mb-4 text-xl xs:mb-6">
                            {t("Contact.Explanatory camper videos")}
                          </h2>
                          <div className="mb-6 md:mb-6">
                            <div className="min-h-[30px] break-words text-sm 2xl:text-2md 2xl:font-normal">
                              {t("Contact.How to extend the awning, and what to do if the heater won't start? Explore valuable tips, smart tricks, and exciting highlights about our campers right here.")}
                            </div>
                          </div>
                          <div className="group/button block disabled:opacity-50 border border-transparent rounded text-md text-white dark:text-off-white bg-primary dark:bg-primary-dark p-3 pl-5 hover:bg-secondary group-hover/parent:bg-secondary dark:hover:text-off-black dark:group-hover/parent:text-off-black dark:hover:bg-off-white dark:group-hover/parent:bg-off-white transition-all shadow dark:shadow-dark hover:shadow-elevated dark:hover:shadow-dark-elevated w-full md:mt-auto">
                            <div className="flex h-full items-center justify-between">
                              <span className="flex">{t("Contact.To the Videos")}</span>
                              <div className="inline-block align-top min-w-max child:h-6 child:w-6 dark:cssvar-secondary-to-off-white ml-2 cssvar-secondary-to-white dark:group-hover/button:cssvar-secondary-to-off-black dark:group-hover/parent:cssvar-secondary-to-off-black">
                                <svg width="32" height="32" viewBox="0 0 32 32">
                                  <g fill="none" fillRule="evenodd">
                                    <path
                                      d="m22.126 16-7.647-7.647a1.207 1.207 0 0 0-1.705 0l-.42.42a1.204 1.204 0 0 0 0 1.705L17.876 16l-5.522 5.522a1.203 1.203 0 0 0 0 1.704l.42.422c.47.47 1.235.469 1.705-.002L22.126 16z"
                                      fill="var(--svg-color-secondary, #fff)"
                                    ></path>
                                  </g>
                                </svg>
                              </div>
                            </div>
                          </div>
                        </div>
                      </Link>
                    </div>
                  </div>

                  <div className="pt-3 2xl:pt-12 md:pb-8 pb-0 2xl:pb-0 text-left mx-auto max-w-3xl availability-info-faq">
                    <h3 className="mobile-center md:my-5 my-8 first:mt-0 break-words text-xl md:text-xl faq-title">
                      {t("rentinfo.Frequently Asked Questions about the")} {camper.title}
                    </h3>
                    {camper.camper_details &&
                      camper.camper_details.map((camper_details) => (
                        <p
                          dangerouslySetInnerHTML={{
                            __html: camper_details.faq_content,
                          }}
                        />
                      ))}
                  </div>

                  <div className="pt-8 2xl:pt-12 md:pb-8 pb-0 2xl:pb-0">
                    <div className="overflow-hidden rounded bg-white shadow dark:bg-off-black-desat dark:shadow-dark 2xs:rounded-lg group/parent mask-image relative p-0 md:flex md:min-h-[400px] md:rounded-xl md:bg-transparent dark:md:bg-transparent justify-end">
                      <Link
                        to={"/equipment"}
                        className="w-full md:flex justify-end"
                        href=""
                      >
                        <div className="md:hidden">
                          <div className="overflow-hidden">
                            <div className="-ml-[5%] w-[110%] overflow-hidden rounded-b-[60%20%] px-[5%]">
                              <div className="relative">
                                <picture className="text-0">
                                  <img className="sm-h-20 inline-block max-w-full object-cover dark:brightness-90 max-h-[40vh] w-full group-hover/parent:scale-110 transition-all duration-300" src="/Images/add-on-1.jpg" alt="" />
                                </picture>
                              </div>
                            </div>
                          </div>
                        </div>
                        <picture className="text-0 absolute top-0 left-0 z-background hidden h-full w-full transition-all duration-300 group-hover/parent:scale-105 md:block md:group-hover/parent:scale-[103%]">
                          <img
                            className="inline-block max-w-full object-cover dark:brightness-90 h-full w-full"
                            src="/Images/add-on-1.jpg"
                            alt=""
                          />
                        </picture>
                        <div className="relative -mt-10 mb-4 flex justify-center xs:mb-4 md:hidden">
                          <div className="inline-block align-top dark:cssvar-white-to-off-white dark:cssvar-secondary-to-secondary dark:cssvar-primary-to-primary-dark child:h-20 child:w-20">
                            <svg
                              width="80px"
                              height="80px"
                              viewBox="0 0 80 80"
                              version="1.1"
                            >
                              <title>usp/laterne_lantern_lampe_licht</title>
                              <g
                                id="usp/laterne_lantern_lampe_licht"
                                stroke="none"
                                strokeWidth="1"
                                fill="none"
                                fillRule="evenodd"
                              >
                                <g id="usp/0-background-circle">
                                  <path
                                    d="M40,0 C62.09139,0 80,17.90861 80,40 C80,62.09139 62.09139,80 40,80 C17.90861,80 0,62.09139 0,40 C0,17.90861 17.90861,0 40,0 Z"
                                    id="Path"
                                    fill="var(--svg-color-primary, #2f2e2e)"
                                  ></path>
                                  <path
                                    d="M40,3.5 C19.8416066,3.5 3.5,19.8416066 3.5,40 C3.5,60.1583934 19.8416066,76.5 40,76.5 C60.1583934,76.5 76.5,60.1583934 76.5,40 C76.5,19.8416066 60.1583934,3.5 40,3.5 Z"
                                    id="Path"
                                    fill="var(--svg-color-white, #FFFFFF)"
                                  ></path>
                                </g>
                                <path
                                  d="M40.005189,9.99616237 C45.7050728,9.99616237 50.3398628,14.5316207 50.3398628,20.1442145 L50.3364867,19.9541624 L54.0070051,19.954773 C54.7651034,19.954773 55.4571932,20.3826088 55.7965705,21.0603486 L59.7970894,29.0572785 C60.1064629,29.6770405 60.0731252,30.4127581 59.709078,31.0025317 C59.344364,31.5909724 58.7009473,31.9501679 58.007524,31.9501679 L54.0070051,31.9501679 L54.0070051,51.9424926 C54.0070051,54.6614488 52.9081959,57.1238368 51.1399665,58.9278109 C56.0918659,60.8873158 59.6731731,65.5817357 59.9855921,71.1427692 C54.2210145,74.8501142 47.3615736,77 40,77 C32.6427085,77 25.7869658,74.8526147 20.0253421,71.1504143 C20.3340958,65.585683 23.9164304,60.8881395 28.8704114,58.9278109 C27.102182,57.1238368 26.0033728,54.6614488 26.0033728,51.9424926 L26.0033728,31.9501679 L22.0028539,31.9501679 C21.3094307,31.9501679 20.6660139,31.5909724 20.3012999,31.0018653 C19.9365859,30.4127581 19.903915,29.6763741 20.2132885,29.0566121 L24.2138074,21.0596822 C24.5531847,20.3826088 25.2452745,19.954773 26.0033728,19.954773 L29.6722884,19.9542055 C29.7754859,14.429613 34.3697681,9.99616237 40.005189,9.99616237 Z M40.005189,63.9378874 C37.795569,63.9378874 36.0046701,65.7278669 36.0046701,67.9363524 C36.0046701,70.1448379 37.795569,71.9348173 40.005189,71.9348173 C42.2148089,71.9348173 44.0057079,70.1448379 44.0057079,67.9363524 C44.0057079,65.7278669 42.2148089,63.9378874 40.005189,63.9378874 Z M50.0064862,31.9501679 L30.0038917,31.9501679 L30.0038917,51.9424926 C30.0038917,55.2498895 32.6955742,57.94019 36.0046701,57.94019 L44.0057079,57.94019 C47.3148037,57.94019 50.0064862,55.2498895 50.0064862,51.9424926 L50.0064862,31.9501679 Z M40.005189,13.3282165 C36.1308953,13.3282165 33.0042809,16.3878221 33.0042809,20.1442145 L33.0064867,19.9541624 L47.0034245,19.9541952 C46.9022933,16.3629383 43.9434082,13.4538633 40.2463373,13.332179 Z"
                                  id="Combined-Shape"
                                  fill="var(--svg-color-secondary, #163435)"
                                ></path>
                                <path
                                  d="M35.0046701,46.6407944 C35.0046701,43.2639532 37.7580034,38.7849054 39.1780034,36.6996015 C39.5938367,36.0880546 40.4113367,36.0907212 40.8255034,36.7040459 C42.2446701,38.8071273 45.0046701,43.3243968 45.0046701,46.6407944 C45.0046701,49.7349729 42.7663367,52.242493 40.0046701,52.242493 C37.2430034,52.242493 35.0046701,49.7349729 35.0046701,46.6407944 Z"
                                  id="Path"
                                  fill="var(--svg-color-primary, #2f2e2e)"
                                ></path>
                                <path
                                  d="M58.5075888,48.9811956 C57.6825181,48.9811956 57.0073943,49.6546649 57.0073943,50.4806218 C57.0073943,51.3055666 57.6822155,51.9800443 58.5075888,51.9800443 C59.3329622,51.9800443 60.0077834,51.3055666 60.0077834,50.4806218 C60.0077834,49.6546649 59.3326596,48.9811956 58.5075888,48.9811956 Z"
                                  id="Path-Copy-17"
                                  fill="var(--svg-color-primary, #2f2e2e)"
                                ></path>
                                <path
                                  d="M47.006097,25.490214 C46.1810263,25.490214 45.5059024,26.1636834 45.5059024,26.9896403 C45.5059024,27.814585 46.1807237,28.4890627 47.006097,28.4890627 C47.8314703,28.4890627 48.5062916,27.814585 48.5062916,26.9896403 C48.5062916,26.1636834 47.8311678,25.490214 47.006097,25.490214 Z"
                                  id="Path-Copy-12"
                                  fill="var(--svg-color-white, #FFFFFF)"
                                ></path>
                                <path
                                  d="M23.0029836,21.9915572 C22.1779129,21.9915572 21.5027891,22.6650266 21.5027891,23.4909834 C21.5027891,24.3159282 22.1776103,24.9904059 23.0029836,24.9904059 C23.828357,24.9904059 24.5031782,24.3159282 24.5031782,23.4909834 C24.5031782,22.6650266 23.8280544,21.9915572 23.0029836,21.9915572 Z"
                                  id="Path-Copy-26"
                                  fill="var(--svg-color-white, #FFFFFF)"
                                ></path>
                                <path
                                  d="M13.5017513,41.4840738 C12.6766805,41.4840738 12.0015567,42.1575432 12.0015567,42.9835 C12.0015567,43.8084448 12.676378,44.4829225 13.5017513,44.4829225 C14.3271246,44.4829225 15.0019459,43.8084448 15.0019459,42.9835 C15.0019459,42.1575432 14.326822,41.4840738 13.5017513,41.4840738 Z"
                                  id="Path-Copy-13"
                                  fill="var(--svg-color-secondary, #163435)"
                                ></path>
                                <path
                                  d="M60.0077834,34.9865683 C59.1827127,34.9865683 58.5075888,35.6600376 58.5075888,36.4859945 C58.5075888,37.3109393 59.1824101,37.985417 60.0077834,37.985417 C60.8331567,37.985417 61.507978,37.3109393 61.507978,36.4859945 C61.507978,35.6600376 60.8328542,34.9865683 60.0077834,34.9865683 Z"
                                  id="Path-Copy-24"
                                  fill="var(--svg-color-secondary, #163435)"
                                ></path>
                                <path
                                  d="M19.5025296,35.4863764 C18.6774588,35.4863764 18.002335,36.1598458 18.002335,36.9858026 C18.002335,37.8107474 18.6771563,38.4852251 19.5025296,38.4852251 C20.3279029,38.4852251 21.0027242,37.8107474 21.0027242,36.9858026 C21.0027242,36.1598458 20.3276004,35.4863764 19.5025296,35.4863764 Z"
                                  id="Path-Copy-14"
                                  fill="var(--svg-color-primary, #2f2e2e)"
                                ></path>
                                <path
                                  d="M12.0015567,26.9896384 C11.1764859,26.9896384 10.5013621,27.6631077 10.5013621,28.4890646 C10.5013621,29.3140094 11.1761834,29.9884871 12.0015567,29.9884871 C12.82693,29.9884871 13.5017513,29.3140094 13.5017513,28.4890646 C13.5017513,27.6631077 12.8266275,26.9896384 12.0015567,26.9896384 Z"
                                  id="Path-Copy-27"
                                  fill="var(--svg-color-primary, #2f2e2e)"
                                ></path>
                                <path
                                  d="M23.0029836,14.9942435 C22.1779129,14.9942435 21.5027891,15.6677129 21.5027891,16.4936698 C21.5027891,17.3186145 22.1776103,17.9930923 23.0029836,17.9930923 C23.828357,17.9930923 24.5031782,17.3186145 24.5031782,16.4936698 C24.5031782,15.6677129 23.8280544,14.9942435 23.0029836,14.9942435 Z"
                                  id="Path-Copy-29"
                                  fill="var(--svg-color-primary, #2f2e2e)"
                                ></path>
                                <path
                                  d="M61.507978,19.4925166 C60.6829073,19.4925166 60.0077834,20.165986 60.0077834,20.9919428 C60.0077834,21.8168876 60.6826047,22.4913653 61.507978,22.4913653 C62.3333513,22.4913653 63.0081726,21.8168876 63.0081726,20.9919428 C63.0081726,20.165986 62.3330488,19.4925166 61.507978,19.4925166 Z"
                                  id="Path-Copy-15"
                                  fill="var(--svg-color-primary, #2f2e2e)"
                                ></path>
                                <path
                                  d="M67.0086915,36.9858008 C66.1836207,36.9858008 65.5084969,37.6592701 65.5084969,38.485227 C65.5084969,39.3101717 66.1833182,39.9846495 67.0086915,39.9846495 C67.8340648,39.9846495 68.5088861,39.3101717 68.5088861,38.485227 C68.5088861,37.6592701 67.8337623,36.9858008 67.0086915,36.9858008 Z"
                                  id="Path-Copy-16"
                                  fill="var(--svg-color-primary, #2f2e2e)"
                                ></path>
                              </g>
                            </svg>
                          </div>
                        </div>
                        <div className="z-0 m-6 mt-0 flex flex-col text-center xs:mt-0 md:m-5 md:mt-5 md:min-h-[calc(100%-theme(spacing.5)*2)] md:w-full md:max-w-1/2 md:rounded-lg md:bg-white md:p-8 md:text-left md:shadow md:dark:bg-off-black-desat xl:max-w-[45%] 2xl:m-9 2xl:mt-9 2xl:min-h-[calc(100%-theme(spacing.9)*2)]">
                          <div className="md:mb-6 mb-2 flex items-center justify-center md:justify-start">
                            <div className="relative mr-4 hidden md:block">
                              <div className="inline-block align-top dark:cssvar-white-to-off-white dark:cssvar-secondary-to-secondary dark:cssvar-primary-to-primary-dark child:h-16 child:w-16">
                                <svg
                                  width="80px"
                                  height="80px"
                                  viewBox="0 0 80 80"
                                  version="1.1"
                                >
                                  <title>usp/laterne_lantern_lampe_licht</title>
                                  <g
                                    id="usp/laterne_lantern_lampe_licht"
                                    stroke="none"
                                    strokeWidth="1"
                                    fill="none"
                                    fillRule="evenodd"
                                  >
                                    <g id="usp/0-background-circle">
                                      <path
                                        d="M40,0 C62.09139,0 80,17.90861 80,40 C80,62.09139 62.09139,80 40,80 C17.90861,80 0,62.09139 0,40 C0,17.90861 17.90861,0 40,0 Z"
                                        id="Path"
                                        fill="var(--svg-color-primary, #2f2e2e)"
                                      ></path>
                                      <path
                                        d="M40,3.5 C19.8416066,3.5 3.5,19.8416066 3.5,40 C3.5,60.1583934 19.8416066,76.5 40,76.5 C60.1583934,76.5 76.5,60.1583934 76.5,40 C76.5,19.8416066 60.1583934,3.5 40,3.5 Z"
                                        id="Path"
                                        fill="var(--svg-color-white, #FFFFFF)"
                                      ></path>
                                    </g>
                                    <path
                                      d="M40.005189,9.99616237 C45.7050728,9.99616237 50.3398628,14.5316207 50.3398628,20.1442145 L50.3364867,19.9541624 L54.0070051,19.954773 C54.7651034,19.954773 55.4571932,20.3826088 55.7965705,21.0603486 L59.7970894,29.0572785 C60.1064629,29.6770405 60.0731252,30.4127581 59.709078,31.0025317 C59.344364,31.5909724 58.7009473,31.9501679 58.007524,31.9501679 L54.0070051,31.9501679 L54.0070051,51.9424926 C54.0070051,54.6614488 52.9081959,57.1238368 51.1399665,58.9278109 C56.0918659,60.8873158 59.6731731,65.5817357 59.9855921,71.1427692 C54.2210145,74.8501142 47.3615736,77 40,77 C32.6427085,77 25.7869658,74.8526147 20.0253421,71.1504143 C20.3340958,65.585683 23.9164304,60.8881395 28.8704114,58.9278109 C27.102182,57.1238368 26.0033728,54.6614488 26.0033728,51.9424926 L26.0033728,31.9501679 L22.0028539,31.9501679 C21.3094307,31.9501679 20.6660139,31.5909724 20.3012999,31.0018653 C19.9365859,30.4127581 19.903915,29.6763741 20.2132885,29.0566121 L24.2138074,21.0596822 C24.5531847,20.3826088 25.2452745,19.954773 26.0033728,19.954773 L29.6722884,19.9542055 C29.7754859,14.429613 34.3697681,9.99616237 40.005189,9.99616237 Z M40.005189,63.9378874 C37.795569,63.9378874 36.0046701,65.7278669 36.0046701,67.9363524 C36.0046701,70.1448379 37.795569,71.9348173 40.005189,71.9348173 C42.2148089,71.9348173 44.0057079,70.1448379 44.0057079,67.9363524 C44.0057079,65.7278669 42.2148089,63.9378874 40.005189,63.9378874 Z M50.0064862,31.9501679 L30.0038917,31.9501679 L30.0038917,51.9424926 C30.0038917,55.2498895 32.6955742,57.94019 36.0046701,57.94019 L44.0057079,57.94019 C47.3148037,57.94019 50.0064862,55.2498895 50.0064862,51.9424926 L50.0064862,31.9501679 Z M40.005189,13.3282165 C36.1308953,13.3282165 33.0042809,16.3878221 33.0042809,20.1442145 L33.0064867,19.9541624 L47.0034245,19.9541952 C46.9022933,16.3629383 43.9434082,13.4538633 40.2463373,13.332179 Z"
                                      id="Combined-Shape"
                                      fill="var(--svg-color-secondary, #163435)"
                                    ></path>
                                    <path
                                      d="M35.0046701,46.6407944 C35.0046701,43.2639532 37.7580034,38.7849054 39.1780034,36.6996015 C39.5938367,36.0880546 40.4113367,36.0907212 40.8255034,36.7040459 C42.2446701,38.8071273 45.0046701,43.3243968 45.0046701,46.6407944 C45.0046701,49.7349729 42.7663367,52.242493 40.0046701,52.242493 C37.2430034,52.242493 35.0046701,49.7349729 35.0046701,46.6407944 Z"
                                      id="Path"
                                      fill="var(--svg-color-primary, #2f2e2e)"
                                    ></path>
                                    <path
                                      d="M58.5075888,48.9811956 C57.6825181,48.9811956 57.0073943,49.6546649 57.0073943,50.4806218 C57.0073943,51.3055666 57.6822155,51.9800443 58.5075888,51.9800443 C59.3329622,51.9800443 60.0077834,51.3055666 60.0077834,50.4806218 C60.0077834,49.6546649 59.3326596,48.9811956 58.5075888,48.9811956 Z"
                                      id="Path-Copy-17"
                                      fill="var(--svg-color-primary, #2f2e2e)"
                                    ></path>
                                    <path
                                      d="M47.006097,25.490214 C46.1810263,25.490214 45.5059024,26.1636834 45.5059024,26.9896403 C45.5059024,27.814585 46.1807237,28.4890627 47.006097,28.4890627 C47.8314703,28.4890627 48.5062916,27.814585 48.5062916,26.9896403 C48.5062916,26.1636834 47.8311678,25.490214 47.006097,25.490214 Z"
                                      id="Path-Copy-12"
                                      fill="var(--svg-color-white, #FFFFFF)"
                                    ></path>
                                    <path
                                      d="M23.0029836,21.9915572 C22.1779129,21.9915572 21.5027891,22.6650266 21.5027891,23.4909834 C21.5027891,24.3159282 22.1776103,24.9904059 23.0029836,24.9904059 C23.828357,24.9904059 24.5031782,24.3159282 24.5031782,23.4909834 C24.5031782,22.6650266 23.8280544,21.9915572 23.0029836,21.9915572 Z"
                                      id="Path-Copy-26"
                                      fill="var(--svg-color-white, #FFFFFF)"
                                    ></path>
                                    <path
                                      d="M13.5017513,41.4840738 C12.6766805,41.4840738 12.0015567,42.1575432 12.0015567,42.9835 C12.0015567,43.8084448 12.676378,44.4829225 13.5017513,44.4829225 C14.3271246,44.4829225 15.0019459,43.8084448 15.0019459,42.9835 C15.0019459,42.1575432 14.326822,41.4840738 13.5017513,41.4840738 Z"
                                      id="Path-Copy-13"
                                      fill="var(--svg-color-secondary, #163435)"
                                    ></path>
                                    <path
                                      d="M60.0077834,34.9865683 C59.1827127,34.9865683 58.5075888,35.6600376 58.5075888,36.4859945 C58.5075888,37.3109393 59.1824101,37.985417 60.0077834,37.985417 C60.8331567,37.985417 61.507978,37.3109393 61.507978,36.4859945 C61.507978,35.6600376 60.8328542,34.9865683 60.0077834,34.9865683 Z"
                                      id="Path-Copy-24"
                                      fill="var(--svg-color-secondary, #163435)"
                                    ></path>
                                    <path
                                      d="M19.5025296,35.4863764 C18.6774588,35.4863764 18.002335,36.1598458 18.002335,36.9858026 C18.002335,37.8107474 18.6771563,38.4852251 19.5025296,38.4852251 C20.3279029,38.4852251 21.0027242,37.8107474 21.0027242,36.9858026 C21.0027242,36.1598458 20.3276004,35.4863764 19.5025296,35.4863764 Z"
                                      id="Path-Copy-14"
                                      fill="var(--svg-color-primary, #2f2e2e)"
                                    ></path>
                                    <path
                                      d="M12.0015567,26.9896384 C11.1764859,26.9896384 10.5013621,27.6631077 10.5013621,28.4890646 C10.5013621,29.3140094 11.1761834,29.9884871 12.0015567,29.9884871 C12.82693,29.9884871 13.5017513,29.3140094 13.5017513,28.4890646 C13.5017513,27.6631077 12.8266275,26.9896384 12.0015567,26.9896384 Z"
                                      id="Path-Copy-27"
                                      fill="var(--svg-color-primary, #2f2e2e)"
                                    ></path>
                                    <path
                                      d="M23.0029836,14.9942435 C22.1779129,14.9942435 21.5027891,15.6677129 21.5027891,16.4936698 C21.5027891,17.3186145 22.1776103,17.9930923 23.0029836,17.9930923 C23.828357,17.9930923 24.5031782,17.3186145 24.5031782,16.4936698 C24.5031782,15.6677129 23.8280544,14.9942435 23.0029836,14.9942435 Z"
                                      id="Path-Copy-29"
                                      fill="var(--svg-color-primary, #2f2e2e)"
                                    ></path>
                                    <path
                                      d="M61.507978,19.4925166 C60.6829073,19.4925166 60.0077834,20.165986 60.0077834,20.9919428 C60.0077834,21.8168876 60.6826047,22.4913653 61.507978,22.4913653 C62.3333513,22.4913653 63.0081726,21.8168876 63.0081726,20.9919428 C63.0081726,20.165986 62.3330488,19.4925166 61.507978,19.4925166 Z"
                                      id="Path-Copy-15"
                                      fill="var(--svg-color-primary, #2f2e2e)"
                                    ></path>
                                    <path
                                      d="M67.0086915,36.9858008 C66.1836207,36.9858008 65.5084969,37.6592701 65.5084969,38.485227 C65.5084969,39.3101717 66.1833182,39.9846495 67.0086915,39.9846495 C67.8340648,39.9846495 68.5088861,39.3101717 68.5088861,38.485227 C68.5088861,37.6592701 67.8337623,36.9858008 67.0086915,36.9858008 Z"
                                      id="Path-Copy-16"
                                      fill="var(--svg-color-primary, #2f2e2e)"
                                    ></path>
                                  </g>
                                </svg>
                              </div>
                            </div>
                            <p className="text-lg small-lg">{t("rentinfo.Add-on equipment")}</p>
                          </div>
                          <h3 className="whitespace-pre-line break-words md:mb-4 mb-2 text-xl xs:mb-6">
                            {t("rentinfo.All you need")}
                          </h3>
                          <div className="mb-4 md:mb-6">
                            <div className="min-h-[30px] break-words text-sm 2xl:text-2md 2xl:font-normal">
                              {t("rentinfo.Would you like to take your bicycle with you, relax in a hammock, or simply enjoy cozy blankets? Explore our additional accessories and find what you're looking for.")}
                            </div>
                          </div>
                          <div className="group/button block disabled:opacity-50 border border-transparent rounded text-md text-white dark:text-off-white bg-primary dark:bg-primary-dark p-3 pl-5 hover:bg-secondary group-hover/parent:bg-secondary dark:hover:text-off-black dark:group-hover/parent:text-off-black dark:hover:bg-off-white dark:group-hover/parent:bg-off-white transition-all shadow dark:shadow-dark hover:shadow-elevated dark:hover:shadow-dark-elevated w-full md:mt-auto">
                            <div className="flex h-full items-center justify-between">
                              <span className="flex">{t("rentinfo.To the equipment")}</span>
                              <div className="inline-block align-top min-w-max child:h-6 child:w-6 dark:cssvar-secondary-to-off-white ml-2 cssvar-secondary-to-white dark:group-hover/button:cssvar-secondary-to-off-black dark:group-hover/parent:cssvar-secondary-to-off-black">
                                <svg width="32" height="32" viewBox="0 0 32 32">
                                  <g fill="none" fillRule="evenodd">
                                    <path
                                      d="m22.126 16-7.647-7.647a1.207 1.207 0 0 0-1.705 0l-.42.42a1.204 1.204 0 0 0 0 1.705L17.876 16l-5.522 5.522a1.203 1.203 0 0 0 0 1.704l.42.422c.47.47 1.235.469 1.705-.002L22.126 16z"
                                      fill="var(--svg-color-secondary, #fff)"
                                    ></path>
                                  </g>
                                </svg>
                              </div>
                            </div>
                          </div>
                        </div>
                      </Link>
                    </div>
                  </div>

                  <div className="pt-8 2xl:pt-12 xl:pb-8 pb-0 2xl:pb-12">
                    <div className="overflow-hidden rounded bg-white  p-4 shadow dark:bg-off-black-desat dark:shadow-dark 2xs:rounded-lg mx-auto flex max-w-3xl flex-col items-center md:p-8 2xl:p-16">
                      <div className="inline-flex items-center justify-center rounded-full border bg-white p-1 dark:bg-off-white mb-6 orange-border">
                        <div className="inline-block align-top child:h-8 child:w-8 2xl:child:h-10 2xl:child:w-10">
                          <svg
                            width="32px"
                            height="32px"
                            viewBox="0 0 32 32"
                            version="1.1"
                          >
                            <title>icon/actions_info</title>
                            <g
                              id="icon/actions_info"
                              stroke="none"
                              strokeWidth="1"
                              fill="none"
                              fillRule="evenodd"
                            >
                              <path
                                d="M15.0627781,13.2833484 C14.2292216,13.2833484 13.4095577,13.2833484 12.5843367,13.2833484 C12.4040026,13.2849033 12.2246588,13.3085077 12.0508606,13.3535621 C11.8387141,13.3950229 11.676741,13.5559636 11.6451964,13.7566407 C11.5865132,13.9746677 11.7037133,14.2006319 11.9230486,14.2923451 C12.190053,14.4092135 12.476874,14.4813856 12.7704977,14.5055866 C13.5429267,14.5393932 13.8541211,14.8566551 13.7374232,15.6004 C13.5206985,16.9916712 13.2289538,18.3725403 12.9788868,19.7612109 C12.809397,20.6973934 12.6848928,21.2550492 12.5843367,22.2403035 C12.4530963,23.5262052 13.2109841,24.7401952 14.1368811,25.0131061 C15.0627781,25.286017 15.724825,25.286017 16.3214484,25.2794864 C17.5999796,25.2780159 18.8212793,24.7831633 19.6973522,23.9116198 C19.8564682,23.7743898 19.9759403,23.6017433 20.0446674,23.409722 C20.0782267,23.2419815 20.0359721,23.0687264 19.9279695,22.9312287 C19.7974575,22.8547704 19.6367149,22.8384803 19.4917416,22.8870201 C19.2639028,22.9572338 19.0610707,23.1028622 18.838789,23.1938799 C18.5790019,23.3073326 18.3070186,23.3945099 18.0274607,23.4539306 C17.8020089,23.5057029 17.5636393,23.4622801 17.3753928,23.335146 C17.1871463,23.2080119 17.0679843,23.0099721 17.0494211,22.7934019 C17.0026623,22.551429 16.9942363,22.3043299 17.0244144,22.0600589 C17.1188841,21.4567414 17.2522531,20.8586248 17.3689511,20.2605082 C17.6857025,18.6291236 18.0070849,16.9968722 18.3330981,15.3637539 C18.4220108,14.9164667 18.5720509,14.4769811 18.4720242,14.0062893 C18.4564927,13.79721 18.3517318,13.6027725 18.1813424,13.4667803 C18.010953,13.3307881 17.7892668,13.2646798 17.5662261,13.2833484 C16.7326696,13.2833484 15.8963346,13.2833484 15.0627781,13.2833484 Z"
                                id="Path"
                                fill="var(--svg-color-secondary, #163435)"
                              ></path>
                              <path
                                d="M16.5742939,6.28268183 C15.5498224,6.23775316 14.6000794,6.81738803 14.1716262,7.74904688 C13.743173,8.68070573 13.9212618,9.77901022 14.6221567,10.5275466 C15.3230516,11.276083 16.4072909,11.52591 17.3650741,11.159561 C18.3228574,10.793212 18.9636082,9.88358197 18.9860507,8.85837141 C19.0250803,7.48444098 17.9479291,6.33655519 16.5742939,6.28823887 L16.5742939,6.28268183 Z"
                                id="Path"
                                fill="var(--svg-color-secondary, #163435)"
                              ></path>
                            </g>
                          </svg>
                        </div>
                      </div>
                      <p className="mb-4 whitespace-pre-line text-center text-lg md:text-xl">
                        {t("aboutus.Questions? We have answers!")}
                      </p>
                      <Link
                        to={"/contactus"}
                        className="button-padding-sm w-full group/button block border border-transparent rounded text-md text-white dark:text-off-white button-primary-bg dark:bg-primary-dark p-3 pl-5 hover:bg-secondary group-hover/parent:bg-secondary dark:hover:text-off-black dark:group-hover/parent:text-off-black dark:hover:bg-off-white dark:group-hover/parent:bg-off-white transition-all shadow dark:shadow-dark hover:shadow-elevated dark:hover:shadow-dark-elevated col-span-2 disabled:opacity-100 sm:col-span-1 text-lg text-center"
                      >
                        <div className="flex h-full items-center justify-between">
                          <div className="inline-block align-top mr-2 rounded-full bg-white p-1 child:h-7 child:w-7 dark:bg-off-white">
                            <svg
                              width="32px"
                              height="32px"
                              viewBox="0 0 32 32"
                              version="1.1"
                            >
                              <title>icon/actions_question</title>
                              <g
                                id="icon/actions_question"
                                stroke="none"
                                strokeWidth="1"
                                fill="none"
                                fillRule="evenodd"
                              >
                                <path
                                  d="M16.5609275,17.3580413 L16.3692127,19.2467266 C15.73983,19.3562778 14.562691,19.3562778 13.8779956,19.3015022 C13.6320422,19.027624 13.6862809,15.1407023 13.6862809,15.1407023 C16.2596615,15.1407023 18.2305102,14.2369044 18.2305102,12.1838923 C18.2305102,11.1442293 17.4915762,9.66582429 15.3837884,9.66582429 C13.4951032,9.66582429 12.1536372,10.6512486 12.1536372,10.6512486 C12.1536372,10.6512486 10.9222596,8.70778776 11.003886,8.05048019 C11.6338057,7.33947102 13.3033885,6.6 15.8767691,6.6 C19.0242198,6.6 21.6523761,8.43390961 21.6523761,11.8831633 C21.6523761,15.1680901 19.2707101,17.0019997 16.5609275,17.3580413 M16.5732788,25.0115932 C15.8048089,25.7891924 14.5471175,25.7972476 13.7695183,25.0287777 C12.9913822,24.2608449 12.9833269,23.0031534 13.7517968,22.2250173 C14.5197297,21.4468811 15.7779581,21.4393629 16.5555573,22.2072957 C17.3336935,22.9757656 17.3412117,24.2334571 16.5732788,25.0115932"
                                  id="Fill-1"
                                  fill="var(--svg-color-secondary, #163435)"
                                ></path>
                              </g>
                            </svg>
                          </div>
                          <span className="flex"> {t("aboutus.To the helpcenter")}</span>
                          <div className="inline-block align-top min-w-max child:h-6 child:w-6 dark:cssvar-secondary-to-off-white ml-2 cssvar-secondary-to-white dark:group-hover/button:cssvar-secondary-to-off-black dark:group-hover/parent:cssvar-secondary-to-off-black">
                            <svg width="32" height="32" viewBox="0 0 32 32">
                              <g fill="none" fillRule="evenodd">
                                <path
                                  d="m22.126 16-7.647-7.647a1.207 1.207 0 0 0-1.705 0l-.42.42a1.204 1.204 0 0 0 0 1.705L17.876 16l-5.522 5.522a1.203 1.203 0 0 0 0 1.704l.42.422c.47.47 1.235.469 1.705-.002L22.126 16z"
                                  fill="var(--svg-color-secondary, #163435)"
                                ></path>
                              </g>
                            </svg>
                          </div>
                        </div>
                      </Link>
                    </div>
                  </div>
                </div>
              </div>

              <div className="lg:col-span-4 custom-index">
                <div className="overflow-hidden rounded bg-white shadow dark:bg-off-black-desat dark:shadow-dark 2xs:rounded-lg sticky ml-8 mt-0 hidden p-5 pt-7 transition-all duration-300 lg:block top-6 sticky-box">
                  <div className="flex max-h-[calc(100vh-80px)] flex-col custom-max-h">
                    <div className="flex max-h-full flex-col items-center overflow-auto text-center">
                      <div className="mb-5 flex items-center justify-center 2xl:mb-2 2xl:flex-col empty-none">
                        {camper.technical &&
                          camper.technical.map((technical) => <></>)}
                      </div>
                      <h2 className="mb-4 whitespace-pre-line text-xl 2xl:text-2xl price-font fw-600">
                        {camper.title}
                      </h2>
                      {camper.camper_details &&
                        camper.camper_details.map((camper_details) => (
                          <h3 className="mb-1 text-lg">
                            {camper_details.sub_title}
                          </h3>
                        ))}
                      <form className="w-full" action="">
                        <input type="hidden" name="lang" value="en" />
                        <input type="hidden" name="camper" value="1040" />
                        <>
                          <div className="relative w-full my-1 custom-select location"></div>
                          <h4 className="mb-1">{t("Rent.Start-Date")}</h4>
                          <div className="relative w-full">
                            <span className="flex h-14 w-full items-center bg-white dark:bg-off-black-desat transition-all child-span:overflow-hidden child-span:text-ellipsis border focus:border-primary focus:outline-none justify-between border-grey hover:shadow dark:border-grey-dark dark:hover:shadow-dark rounded">
                              <div className="inline-block align-top ml-3 mr-1 min-w-fit child:h-7 child:w-7 dark:cssvar-secondary-to-off-white">
                                <svg width="32" height="32" viewBox="0 0 32 32">
                                  <g fill="none" fillRule="evenodd">
                                    <path
                                      d="M21.06 4.5c.474 0 .884.3 1.01.741l.028.124.01.127-.002 1.327h1.14c1.503 0 2.772 1.005 3.049 2.362l.03.179.019.182.006.183v13.87c0 1.476-1.178 2.7-2.715 2.882l-.194.017-.195.006H9.104c-1.569 0-2.882-1.094-3.079-2.54l-.019-.183L6 23.595V9.725c0-1.477 1.178-2.7 2.715-2.882l.194-.018.195-.005 1.139-.001V5.492c0-.473.347-.864.808-.966l.117-.02.121-.006c.473 0 .883.3 1.01.741l.027.124.01.127-.001 1.327h2.858V5.463c0-.452.316-.828.74-.934l.12-.022.122-.007a.98.98 0 0 1 .941.697l.029.117.012.149-.002 1.356h2.859V5.492c0-.473.348-.864.808-.966l.117-.02.122-.006zm3.197 7.015H8.092v11.989c0 .473.328.877.764.983l.122.021.126.007h14.142c.476 0 .878-.33.983-.764l.021-.122.007-.125V11.515zm-7.883 1.614 1.085 2.516c.031.071.097.12.174.129l2.75.28c.187.02.26.253.118.377l-2.072 1.791a.214.214 0 0 0-.07.21l.613 2.73a.215.215 0 0 1-.321.23l-2.365-1.446a.214.214 0 0 0-.222 0L13.7 21.393a.215.215 0 0 1-.32-.232l.611-2.729a.215.215 0 0 0-.07-.21l-2.071-1.79a.215.215 0 0 1 .118-.377l2.75-.281a.212.212 0 0 0 .174-.129l1.085-2.516a.217.217 0 0 1 .397 0z"
                                      fill="var(--svg-color-secondary, #163435)"
                                    ></path>
                                  </g>
                                </svg>
                              </div>

                              <span
                                className="text-ellipsis whitespace-nowrap text-md custom-calender single-calender"
                                onClick={() =>
                                  setCalendarIsOpen(!calendarIsOpen)
                                }
                              >
                                <DatePicker
                                  selected={excludeDates.length == daysRange ? "" : startDate}
                                  onChange={onChangedate}
                                  excludeDates={isCalendarStatus === 1 || excludeDates.length === 0 ? [] : excludeDates}
                                  minDate={isCalendarStatus === 1 ? "" : minSelectableDate}
                                  // maxDate={isCalendarStatus === 1 ? addMonths(new Date(), 24) : addMonths(new Date(), 12)}
                                  maxDate={addDays(new Date(), 730)}
                                  renderDayContents={renderDayContents}
                                  dateFormat="dd/MM/yyyy"
                                  locale={i18n.resolvedLanguage}
                                  calendarStartDay={1}
                                  monthsShown={1}
                                  withPortal
                                  placeholderText={t("Rent.Whenever")}
                                  onFocus={e => e.target.blur()}
                                  ref={pickerRef}
                                  required
                                  onKeyDown={(e) => e.preventDefault()}
                                  renderCustomHeader={({
                                    date,
                                    decreaseMonth,
                                    increaseMonth,
                                    prevMonthButtonDisabled,
                                    nextMonthButtonDisabled,
                                  }) => {
                                    // Call the function we created in Step 2
                                    const info = getSeasonalInfo(date);

                                    // Dynamic Styles based on theme
                                    const bgClass = info.theme === "orange"
                                      ? "bg-orange-50 border-orange-200 text-orange-800"
                                      : "bg-blue-50 border-blue-200 text-blue-800";

                                    return (
                                      <div className="flex flex-col">
                                        {/* 1. Seasonal Banner */}
                                        <div className={`calender-banner mx-2 mt-2 mb-2 rounded-lg border px-2 py-1 shadow-sm ${bgClass}`}>
                                          <div className="flex items-center justify-center gap-2 text-xs font-bold">
                                            <span>{info.icon}</span>
                                            <span className="banner-season-title">{info.title}</span>
                                          </div>
                                          <hr />
                                          {/* 2. Instruction Text */}
                                          <div className="text-center text-xs text-gray-500 banner-season-title">
                                            {t("Rent.Start on your preferred date")}
                                          </div>
                                        </div>

                                        {/* 3. Navigation */}
                                        <div className="flex items-center justify-between px-2 custom-header mx-3">
                                          <button
                                            onClick={decreaseMonth}
                                            disabled={prevMonthButtonDisabled}
                                            type="button"
                                            className={`h-8 w-8 flex items-center justify-center rounded-full hover:bg-gray-100 ${prevMonthButtonDisabled ? 'opacity-50' : ''}`}
                                          >
                                            <span className="text-gray-600 font-bold">{<svg xmlns="http://www.w3.org/2000/svg" width="800px" height="800px" viewBox="0 0 24 24" fill="none">
                                              <path d="M15 6L9 12L15 18" stroke="#000000" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                            </svg>}</span>
                                          </button>

                                          <span className="text-lg font-bold text-gray-800">
                                            {moment(date).locale(i18n.resolvedLanguage).format("MMMM yyyy")}
                                          </span>

                                          <button
                                            onClick={increaseMonth}
                                            disabled={nextMonthButtonDisabled}
                                            type="button"
                                            className={`h-8 w-8 flex items-center justify-center rounded-full hover:bg-gray-100 ${nextMonthButtonDisabled ? 'opacity-50' : ''}`}
                                          >
                                            <span className="text-gray-600 font-bold">{<svg xmlns="http://www.w3.org/2000/svg" width="800px" height="800px" viewBox="0 0 24 24" fill="none">
                                              <path d="M9 6L15 12L9 18" stroke="#000000" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                            </svg>}</span>
                                          </button>
                                        </div>

                                        {/* 4. Dynamic Price */}
                                        <div className="text-center font-bold text-slate-800 mt-1 price-font">
                                          {info.price}€ / {t("subscription.Month")}
                                        </div>
                                      </div>
                                    );
                                  }}
                                >
                                  <div
                                    className="calender-status"
                                    style={{
                                      display: "flex",
                                      justifyContent: "center",
                                      gap: "0",
                                      padding: "15px",
                                      borderTop: "1px solid #ddd",
                                      marginTop: "5px",
                                    }}
                                  >
                                    <div className="max-w-md mb-3 mt-2">
                                      <div className="flex items-start gap-2 rounded-xl bg-blue-50 px-4 py-3 shadow-sm">
                                        <div className="flex h-8 w-8 items-center justify-center">
                                          <img
                                            className="h-5 w-5 text-yellow-400"
                                            src="/svg-icon/light-bulb-idea-svgrepo-com.svg"
                                            alt="Info Icon"
                                          />
                                        </div>

                                        <p className="info-note text-sm text-gray-700 flex flex-wrap whitespace-normal text-start">
                                          {t("Rent.Monthly prices are prorated by day based on your start date.")}
                                        </p>
                                      </div>
                                    </div>

                                    <div
                                      style={{
                                        display: "flex",
                                        alignItems: "center",
                                        gap: "5px",
                                      }}
                                    >
                                      <span
                                        style={{
                                          width: "12px",
                                          height: "12px",
                                          backgroundColor: "white",
                                          border: "1px solid black",
                                          borderRadius: "50%",
                                        }}
                                      ></span>
                                      <span style={{ fontSize: "12px" }}>
                                        {t("Rent.Fully available")}
                                      </span>
                                    </div>
                                    <div
                                      style={{
                                        display: "flex",
                                        alignItems: "center",
                                        gap: "5px",
                                      }}
                                    >
                                      <span
                                        style={{
                                          width: "12px",
                                          height: "12px",
                                          backgroundColor: "red",
                                          borderRadius: "50%",
                                        }}
                                      ></span>
                                      <span style={{ fontSize: "12px" }}>
                                        {t("Rent.Vehicle not available")}
                                      </span>
                                    </div>
                                    <div
                                      style={{
                                        display: "flex",
                                        alignItems: "center",
                                        gap: "5px",
                                      }}
                                    >
                                      <span
                                        style={{
                                          width: "12px",
                                          height: "12px",
                                          backgroundColor: "orange",
                                          borderRadius: "50%",
                                        }}
                                      ></span>
                                      <span style={{ fontSize: "12px" }}>
                                        {t(
                                          "Rent.Pickup/return not possible, bookings are allowed"
                                        )}
                                      </span>
                                    </div>
                                  </div>
                                </DatePicker>
                              </span>
                              <div className="inline-block align-top ml-2 mr-4 min-w-fit transition-all child:h-6 child:w-6 dark:cssvar-secondary-to-off-white">
                                <svg width="32" height="32" viewBox="0 0 32 32">
                                  <g fill="none" fillRule="evenodd">
                                    <path
                                      d="m16 22.126 7.647-7.647c.47-.47.47-1.234 0-1.705l-.42-.42a1.204 1.204 0 0 0-1.705 0L16 17.876l-5.522-5.522a1.203 1.203 0 0 0-1.704 0l-.422.42c-.47.47-.469 1.235.002 1.705L16 22.126z"
                                      fill="var(--svg-color-secondary, #163435)"
                                    ></path>
                                  </g>
                                </svg>
                              </div>
                            </span>
                          </div>
                          {(errorStartDate && !startDate) ? (
                            <p
                              style={{ color: "red" }}
                              className="mb-2 mt-3 flex w-full animate-wiggle items-center justify-between rounded bg-warning px-4 py-2 text-lg text-white"
                            >
                              {errorStartDate}
                            </p>
                          ) : (
                            ""
                          )}
                          <h4 className="mt-3 mb-1">{t("Rent.Duration")}</h4>
                          <div className="w-full custom-pickup-return custom-months-select">
                            <div>
                              <span className="group outline-none">
                                <div className="relative flex items-center  border-opacity-disabled  block w-full cursor-default">
                                  <div className="flex items-center justify-between w-full opacity-disabled">
                                    <svg
                                      className="watch  w-7 h-7"
                                      width="32"
                                      height="32"
                                      aria-hidden="true"
                                    >
                                      <svg
                                        viewBox="0 0 32 32"
                                        fill="none"
                                        id="icon-clock-pickup"
                                      >
                                        <path
                                          fillRule="evenodd"
                                          clipRule="evenodd"
                                          d="M16.0004 5C22.0659 5 27 9.93484 27 16.0005C27 22.0662 22.0659 27 16.0004 27C9.93476 27 5 22.0662 5 16.0005C5 9.93484 9.93476 5 16.0004 5ZM16.0003 7.5C11.3151 7.5 7.5 11.3152 7.5 16.0005C7.5 20.6856 11.3149 24.5 16.0003 24.5C20.6856 24.5 24.5 20.6857 24.5 16.0005C24.5 11.315 20.6854 7.5 16.0003 7.5ZM16.2214 8.62618C16.5932 8.62618 16.7491 8.9661 16.7562 9.15491L17.2087 15.5123L20.6275 19.6289C20.75 19.7731 20.8682 20.1356 20.5685 20.436C20.2671 20.7364 19.9044 20.6213 19.7601 20.4947L14.8275 17.0998C14.6903 16.9776 14.629 16.8032 14.6225 16.6184C14.5827 16.5205 14.5559 16.4134 14.5635 16.299L15.6858 9.15491C15.6977 8.9661 15.8488 8.62618 16.2214 8.62618ZM28 0L32 7H24L28 0Z"
                                          fill="var(--svg-custom-color, var(--svg-color-secondary, #163435))"
                                        ></path>
                                      </svg>
                                    </svg>
                                    {/* Duration */}
                                    <Select
                                      // autoFocus
                                      backspaceRemovesValue={false}
                                      hideSelectedOptions={false}
                                      tabSelectsValue={false}
                                      className="react-select-container w-full"
                                      classNamePrefix="react-select"
                                      options={monthoptions}
                                      onChange={handleMonth}
                                      isSearchable={false}
                                      value={monthselect}
                                      placeholder={t("Rent.Select a duration")}
                                      // formatOptionLabel={(option, { context }) => {
                                      //   if (context == 'menu') {
                                      //     return option.label;
                                      //   }
                                      //   return `${option.value} ${t("Rent.Months")}`;
                                      // }}
                                    />
                                    <svg
                                      className="down-arrow w-7 h-7"
                                      width="32"
                                      height="32"
                                      aria-hidden="true"
                                    >
                                      <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        viewBox="0 0 32 32"
                                        fill="none"
                                        id="icon-chevron-down"
                                      >
                                        <path
                                          fillRule="evenodd"
                                          clipRule="evenodd"
                                          d="M16.0001 22.1256L23.6467 14.479C24.1173 14.009 24.1179 13.2445 23.6479 12.7739L23.2266 12.3532C22.7542 11.8809 21.9927 11.8833 21.5215 12.3544L16.0001 17.8759L10.4781 12.3544C10.0075 11.8833 9.24543 11.8809 8.77364 12.3532L8.35234 12.7739C7.88175 13.2445 7.88296 14.009 8.35354 14.479L16.0001 22.1256Z"
                                          fill="var(--svg-custom-color, var(--svg-color-secondary, #163435))"
                                        ></path>
                                      </svg>
                                    </svg>
                                  </div>
                                </div>
                              </span>
                            </div>
                          </div>
                          {(errorMonthselect && !monthselect) ? (
                            <p
                              style={{ color: "red" }}
                              className="mb-2 mt-3 flex w-full animate-wiggle items-center justify-between rounded bg-warning px-4 py-2 text-lg text-white"
                            >
                              {errorMonthselect}
                            </p>
                          ) : (
                            ""
                          )}
                        </>
                        <div className="mt-4 w-full rounded bg-off-white p-5 text-left dark:bg-black">
                          {camper.inclusive &&
                            camper.inclusive.map((inclusive) => (
                              <div className="mb-4 flex items-center last:mb-0">
                                <div className="inline-flex items-center justify-center rounded-full border border-primary bg-white dark:border-primary-dark dark:bg-off-white mr-3 p-0">
                                  <div className="inline-block align-top child:h-6 child:w-6">
                                    <svg
                                      width="32"
                                      height="32"
                                      viewBox="0 0 32 32"
                                    >
                                      <g fill="none" fillRule="evenodd">
                                        <path
                                          d="m21.906 9.488-8.547 9.56-3.45-3.096a1.757 1.757 0 0 0-2.563.209c-.64.792-.547 1.98.21 2.659l4.764 4.274c.735.66 1.833.602 2.496-.13l9.73-10.869a1.954 1.954 0 0 0-.069-2.665 1.758 1.758 0 0 0-2.571.058z"
                                          fill="var(--svg-color-secondary, #163435)"
                                        ></path>
                                      </g>
                                    </svg>
                                  </div>
                                </div>
                                <p className="text-md">{inclusive.i_title}</p>
                              </div>
                            ))}
                        </div>

                        <div className="my-4 flex min-h-[70px] w-full flex-col justify-center 2xl:my-8">


                          <div className="mb-1 text-xl text-primary dark:text-primary-light">
                            {/* {t("Rent.from")}{" "}
                            <span className="text-xl price-font text-md inline-block align-bottom">
                              {camper.camper_price &&
                                camper.camper_price.map((camper_price) => (
                                  <NumericFormat
                                    value={totalcamperprice}
                                    thousandSeparator={"."}
                                    decimalSeparator={","}
                                    displayType={"text"}
                                  />
                                ))}
                              €
                            </span> */}
                          </div>
                          
                          {/* <p className="text-xs mb-4"> {t("subscription.per Month")} </p> */}
                            <div className="max-w-full mb-5">
                              <div className="flex items-center gap-2 rounded-xl bg-blue-50 px-4 py-3 shadow-sm">
                                {/* Icon */}
                                <div className="flex h-8 w-8 items-center justify-center">
                                  <img
                                    className="h-5 w-5 text-yellow-400"
                                    src="/svg-icon/lock.svg"
                                    alt="Info Icon"
                                  />
                                </div>

                                {/* Text */}
                                <p className="info-note text-sm text-gray-700 flex flex-wrap whitespace-normal text-start">
                                  {t("Rent.Monthly payment.")}
                                  <br />
                                  {t("Rent.Full cost transparency from the start.")}
                                </p>
                              </div>
                            </div>

                          {error ? (
                            <p
                              style={{ color: "red" }}
                              className="mb-2 flex w-full animate-wiggle items-center justify-between rounded bg-warning px-4 py-2 text-lg text-white"
                            >
                              {error}
                            </p>
                          ) : (
                            ""
                          )}
                            

                          {ExcludedateList.length == daysRange ? (
                            <>
                              <p
                                style={{ color: "red" }}
                                className="mb-2 flex w-full animate-wiggle items-center justify-between rounded bg-warning px-4 py-2 text-lg text-white"
                              >
                                {t("rentinfo.Inventory is not available")}
                              </p>
                              <Link
                                to="#"
                                className="group/button block disabled:opacity-50 border border-transparent rounded text-md text-white dark:text-off-white bg-primary dark:bg-primary-dark p-3 pl-5 hover:bg-secondary group-hover/parent:bg-secondary dark:hover:text-off-black dark:group-hover/parent:text-off-black dark:hover:bg-off-white dark:group-hover/parent:bg-off-white transition-all shadow dark:shadow-dark hover:shadow-elevated dark:hover:shadow-dark-elevated w-full"
                              >
                                <div className="flex h-full items-center justify-between">
                                  <span className="flex">{t("rentinfo.Configure now")}</span>
                                  <div className="inline-block align-top min-w-max child:h-6 child:w-6 dark:cssvar-secondary-to-off-white ml-2 cssvar-secondary-to-white dark:group-hover/button:cssvar-secondary-to-off-black dark:group-hover/parent:cssvar-secondary-to-off-black">
                                    <svg
                                      width="32"
                                      height="32"
                                      viewBox="0 0 32 32"
                                    >
                                      <g fill="none" fillRule="evenodd">
                                        <path
                                          d="m22.126 16-7.647-7.647a1.207 1.207 0 0 0-1.705 0l-.42.42a1.204 1.204 0 0 0 0 1.705L17.876 16l-5.522 5.522a1.203 1.203 0 0 0 0 1.704l.42.422c.47.47 1.235.469 1.705-.002L22.126 16z"
                                          fill="var(--svg-color-secondary, #fff)"
                                        ></path>
                                      </g>
                                    </svg>
                                  </div>
                                </div>
                              </Link>{" "}
                            </>
                          ) : (
                            <Button
                              onClick={(e) => handleCheckout(camper.id)}
                              className="group/button block disabled:opacity-50 border border-transparent rounded text-md text-white dark:text-off-white bg-primary dark:bg-primary-dark p-3 pl-5 hover:bg-secondary group-hover/parent:bg-secondary dark:hover:text-off-black dark:group-hover/parent:text-off-black dark:hover:bg-off-white dark:group-hover/parent:bg-off-white transition-all shadow dark:shadow-dark hover:shadow-elevated dark:hover:shadow-dark-elevated w-full"
                            >
                              <div className="flex h-full items-center justify-between">
                                <span className="flex">{t("rentinfo.Configure now")}</span>
                                <div className="inline-block align-top min-w-max child:h-6 child:w-6 dark:cssvar-secondary-to-off-white ml-2 cssvar-secondary-to-white dark:group-hover/button:cssvar-secondary-to-off-black dark:group-hover/parent:cssvar-secondary-to-off-black">
                                  <svg
                                    width="32"
                                    height="32"
                                    viewBox="0 0 32 32"
                                  >
                                    <g fill="none" fillRule="evenodd">
                                      <path
                                        d="m22.126 16-7.647-7.647a1.207 1.207 0 0 0-1.705 0l-.42.42a1.204 1.204 0 0 0 0 1.705L17.876 16l-5.522 5.522a1.203 1.203 0 0 0 0 1.704l.42.422c.47.47 1.235.469 1.705-.002L22.126 16z"
                                        fill="var(--svg-color-secondary, #fff)"
                                      ></path>
                                    </g>
                                  </svg>
                                </div>
                              </div>
                            </Button>
                          )}
                        </div>
                      </form>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </main>
          <Footer />
        </>
      )}
    </>
  );
};
export default AvailabilityinfoSubscription;
